<template>
<div>
  <card>
    <h4>January 9, 2025
      <!--          <i class="tim-icons icon-minimal-down"></i>-->
    </h4>
    <div>
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          New booking bulk actions: ability to change custom pricing and add a note.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Customizable note field with support for dynamic variables on Square payments.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Option to create a customer in the Square system during Square payment events.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed random and schedule slot modification due to slot id collisions.
        </li>
        <li>
          Ensured that cancelled bookings are not listed in booking confirmation emails.
        </li>
        <li>
          Fixed client side reactivity bug preventing the Anonymous Resource toggle from working on Schedules.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(115)">January 2, 2025
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[115] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Ability to restrict booking time slots bulk actions to specific time ranges.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the bug preventing users from creating new pricing categories on Game Settings.
        </li>
        <li>
          Reordered server side validation flow to prevent duplicate booking slots creation on game reschedule when validation checks fail.
        </li>
        <li>
          Additional bug fixes on account billing flow.
        </li>
        <li>
          Ensured that the schedule calendar time grid does not collapse when rounding up time slot end times.
        </li>
        <li>
          Ensured that actions on payments are still be available even if no amount is due.
        </li>
        <li>
          Fixed the calendar view such that slots spanning more than two days are still visible for every day in range.
        </li>
        <li>
          Added client and server side validation on refund amount field.
        </li>
        <li>
          Added a server side check on applied gift card amounts.
        </li>
        <li>
          Fixed bugs on the future slot generator function, causing unwanted slot duplication and incorrect end date.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(114)">December 26, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[114] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="info">integrations</badge>
          Google calendar integration.
        </li>
        <li>
          <badge type="success">settings</badge>
          Ability for users to deactivate a company account.
        </li>
        <li>
          <badge type="success">schedules</badge>
          Improved batch handling on schedules.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Additional bug fixes on account billing flow.
        </li>
        <li>
          Addressed the bug causing redirect to occasionally stall on login.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(113)">December 19, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[113] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Webhook endpoint for capturing Square events.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to edit gift card recipient name and email.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Confirmation alert to users when a gift card is successfully applied to cart.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Option to waive a fee on gift card purchases.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Tooltip on value type field when configuring promo codes.
        </li>
        <li>
          <badge type="default">security</badge>
          Masking sensitive API token values on Payment Gateway page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Added minor improvements and bug fixes to account billing flow.
        </li>
        <li>
          Fixed formatting bug on partial amount when splitting payment between Authorize.net and gift cards.
        </li>
        <li>
          Ensured that applied gift card payments are reverted back when combined with a Stripe card payment, which fails.
        </li>
        <li>
          Fixed character escaping on Gift Card download CSV.
        </li>
        <li>
          Proper timezone check and more a frequent schedule on the cron job marking booking slots as passed.
        </li>
        <li>
          Fixed the bug where the schedule future slots validator endpoint was passing the wrong date ranges after schedule type toggle.
        </li>
        <li>
          Ensured that the Stripe payment intent value is properly regenerated on payment request page after a payment fails.
        </li>
        <li>
          Ensured that gift cards created internally have their delivery dates set correctly.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(112)">December 12, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[112] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">schedules</badge>
          Ability to edit start and day on timeslot popup.
        </li>
        <li>
          <badge type="warning">general</badge>
          Improved timezone selection and handling.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Setting to show or hide passed event slots on waiver page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Ensured that existing resource assignments are correctly cleared and remapped when editing booking slots.
        </li>
        <li>
          Ensures that transaction date on confirmation emails respects company group timezone settings.
        </li>
        <li>
          Fixed the bug preventing abandoned cart delivery time settings from saving correctly.
        </li>
        <li>
          Ensured that booking list list view displays game images in order.
        </li>
        <li>
          Updated the assigned/available resource counts by slot on booking list view.
        </li>
        <li>
          Ensured that the waiver redirect button is being displayed or hidden according to booking site settings.
        </li>
        <li>
          Added throttling and progress bar on report downloads to prevent timeouts on large data set downloads.
        </li>
        <li>
          Fixed broken game filter on mobile screens on game history.
        </li>
        <li>
          Ensured that resource validator endpoint is passed the correct end date when rescheduling an existing booking.
        </li>
        <li>
          Ensured that the loading screen is aborted if resource validation fails when rescheduling a booking.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(111)">December 5, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[111] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="default">resource management</badge>
          Bulk action to clear booking slot assignments on resource slots.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          A settings section for gift cards, allowing users to configure custom text and image for custom appearance on the booking site.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Edit activation and expiration dates on existing gift cards
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Activate and deactivate existing gift cards.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Tooltip on "Validate redemption email" field for clarity.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Option to create overlapping slots on top of existing bookings during schedule update.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed a bug on schedule slots generation preventing correct creation of pipelined slots.
        </li>
        <li>
          For Stripe users, delayed gift card confirmation email until webhook confirmation to prevent confirmation emails in cases when payment fails.
        </li>
        <li>
          Fixed the discrepancy issue between booking slots and the corresponding pricing category links
          which made pricing categories appear incorrectly on certain booking slots.
        </li>
        <li>
          Corrected section duplication on  gift card delivery email preview page.
        </li>
        <li>
          Added server side validation on gift card types for external bookings.
        </li>
        <li>
          Ensured that end date is set correctly when rescheduling a booking from transaction details page.
        </li>
        <li>
          Ensured that customer credit value on booking calendar is cleared when selecting a new customer without credit available.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(110)">November 29, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[110] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Overhaul to gift cards settings, enabling users to create gift card types with more flexibility.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          New fields on gift cards: activation date, purchase value, and purchase price. Users can now sell gift cards at a discounted value.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Enhanced image editing options for gift card designs.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Ensured that taxes are not reapplied to gift card purchases when updating transaction details.
        </li>
        <li>
          Fixed the bug preventing users from disabling custom pricing on a booking slot.
        </li>
      </ul>
    </div>

    <h4  v-on:click="toggle(109)">November 21, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[109] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Setting to optionally prevent gift card purchases with other gift cards
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Added client side validation on date fields on schedule create and update.
        </li>
        <li>
          Improved calendar time grid automatic readjustment on schedules.
        </li>
        <li>
          Ensured that time slot labeling on cross day slots are accurate on schedules.
        </li>
        <li>
          Ensured that the custom deposit setting on Transaction Details page is respected on Payment Request, such that total value is not displayed.
        </li>
        <li>
          Ensured that the submit button is disabled at the correct time when making payments on booking calendar and list pages.
        </li>
        <li>
          Removed the error message when there is a game tracker conflict on schedule update and instead made the booking slot status automatically correct itself.
        </li>
        <li>
          Fixed waiver final step redirect that was blocked on certain mobile devices.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(108)">November 15, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[108] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">games</badge>
          Ability to configure the number of resources a game requires.
        </li>
        <li>
          <badge type="success">games</badge>
          Option to set a game to block all other concurrent slots.
        </li>
        <li>
          <badge type="default">resource management</badge>
          New fields on resource slots and resource schedules: number of events supported at the same time, label, staff assignment.
        </li>
        <li>
          <badge type="default">resource management</badge>
          Automatic and manual assignment of booking slots to resource slots.
        </li>
        <li>
          <badge type="default">resource management</badge>
          Updated auto-blocking algorithm, capable of tracking when a given resource is assigned to and freed up from events.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Ensured that the end date of a booking is factored in when rescheduling bookings.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(107)">November 7, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[107] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">checklists</badge>
          Ability to reorder checklists.
        </li>
        <li>
          <badge type="success">checklists</badge>
          Ability to duplicate checklists.
        </li>
        <li>
          <badge type="success">checklists</badge>
          Ability to have checklists open in different tabs.
        </li>
        <li>
          <badge type="success">games</badge>
          Ability to duplicate games.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Payment request link to copy on transaction details page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Added granularity to transaction failed error message on booking site.
        </li>
        <li>
          Ensured that amount due field is correctly pre-populated when apply credit is selected on add payment popup.
        </li>
        <li>
          Fixed the issue where subtotal value wasn't retrieved correctly when applying a promo code to gift card.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(106)">October 29, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[106] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">email</badge>
          Automated email template for gift card purchases.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Support for booking and resource slots spanning across multiple days.
        </li>
        <li>
          <badge type="success">settings</badge>
          Ability for admins to update company users' email addresses.
        </li>
        <li>
          <badge type="success">settings</badge>
          New permission for downloading data across the platform.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Added link to waiver kiosk mode on waiver settings.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed rounding precision issue on internal payment update.
        </li>
        <li>
          Fixed action icon overlap on Survey Edit page by replacing them with a dropdown menu.
        </li>
        <li>
          Resolved the issues with dragging survey questions while editing by replacing inline editing with a popup.
        </li>
        <li>
          Added validation for creating payments with empty payment method.
        </li>
        <li>
          Ensured that payment methods are loaded at the right time on calendar pages.
        </li>
        <li>
          Ensured that tip amount is correctly factored in when recalculating values after applying discount internally.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(105)">October 24, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[105] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Optional setting to show taxes and fees when displaying item price on the booking site.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          New optional fields for company number and tax number to be shown on invoices.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to configure purchase methods for internal as well as external payments.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          On booking list view, add default booking date when creating a new booking or time slot.
        </li>
        <li>
          <badge type="success">localization</badge>
          Improved internationalization on internal and external field labels and placeholder, including zip, phone number, city, state etc. for all supported countries.
        </li>
        <li>
          <badge type="success">settings</badge>
          Tracking of account trial dates.
        </li>
        <li>
          <badge type="success">settings</badge>
          Added "Last login" field for company users.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Relabeled Yappy payments.
        </li>
        <li>
          Added GA4 and pixel evet tracking for Yappy flow.
        </li>
        <li>
          On booking site, removed redirect to first page on failed payment.
        </li>
        <li>
          Added DNS verification for MAIL FROM field for automated emails.
        </li>
        <li>
          Fixed empty phone number issue in automated emails.
        </li>
        <li>
          Ensured that categories for 0 ticket count on bookings are still shown on booking edit.
        </li>
        <li>
          Fixed client side RBAC issues on gift card edit, create, and delete actions.
        </li>
        <li>
          Added concurrency to schedule creator function to allow for simultaneous schedule generation of multiple reccuring game schedules.
        </li>
        <li>
          Addressed autoblocking issue where booked slots were double counted in certain cases.
        </li>
        <li>
          Fixed automated email preview issue where the intro section was not shown.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(104)">October 17, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[104] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">settings</badge>
          Require credit card on file before activating features past trial period.
        </li>
        <li>
          <badge type="success">settings</badge>
          Trial banner with countdown. Deactivating features if no credit card has been added before trial end.
        </li>
        <li>
          <badge type="success">settings</badge>
          Automated billing and invoices.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Separated our promo codes to a separate menu tab.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to view and reactivate archived promo codes.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to copy promo codes across all groups.
        </li>
        <li>
          <badge type="success">games</badge>
          Option to play video hints on loop.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Links from Event Log to specific booking slots.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed timestamp rendering inconsistency for Email Events on Transaction Details page.
        </li>
        <li>
          Fixed Square card widget rendering issue on internal cart page.
        </li>
        <li>
          Removed deactivated employees from site-wide staff searches.
        </li>
        <li>
          Converted overlay deletion to archival to retain applied overlay history.
        </li>
        <li>
          Addressed text font loading lag when applying overlays.
        </li>
        <li>
          Fixed reminder email scheduling automation to prevent emails from sending if a booking was made within the set time window.
        </li>
        <li>
          Fixed the email template locale formatting issue affecting NZ customers.
        </li>
        <li>
          Ensured that all retroactive automated emails (follow-up, abandoned cart, and survey emails) trigger after the respective template is enabled.
        </li>
        <li>
          Ensured that the feature to verify DNS also verifies AWS SES identity.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(103)">October 10, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[103] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">settings</badge>
          Ability to add payment method for billing.
        </li>
        <li>
          <badge type="success">settings</badge>
          View and download billing statements.
        </li>
        <li>
          <badge type="success">settings</badge>
          Mobile view for the billing page.
        </li>
        <li>
          <badge type="success">settings</badge>
          New Feature filter on event logs.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Default to game pricing values when the user first enables custom pricing.
        </li>
        <li>
          <badge type="default">inventory management</badge>
          Persistent filters for inventory items.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Mitigated the 50 email limit on the IDP.
        </li>
        <li>
          Fixed the bug where gift card values were not recalculated after promo code application.
        </li>
        <li>
          Ensured that legacy pricing model persists with the booking even after pricing model changes on a game.
        </li>
        <li>
          Made it so booking import on migrations overwrite existing available slots.
        </li>
        <li>
          Fixed the booking time rendering issue on transaction details after canceling booking edit.
        </li>
        <li>
          Added missing actions dropdown on mobile booking list and calendar view.
        </li>
        <li>
          Ensured that time slots were populating correctly on initial "Book Now" click on list view.
        </li>
        <li>
          Fixed the bug with exclusion date field rendering on promo codes.
        </li>

      </ul>
    </div>

    <h4 v-on:click="toggle(102)">October 3, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[102] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Optional setting on custom fields to force user interaction before being able to check the custom field checkbox.
        </li>
        <li>
          <badge type="success">schedules</badge>
          Ability to save schedule as a new schedule, copying over schedule settings.
        </li>
        <li>
          <badge type="success">schedules</badge>
          Added an error message on the feature to generate schedule slots whenever user-supplied settings do not produce slots.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Option to add a custom charge on Transaction details page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to create a standalone transaction without an associated booking.
        </li>
        <li>
          <badge type="warning">reports</badge>
          Added Tax and Fee fields on Purchases report.
        </li>
        <li>
          <badge type="warning">reports</badge>
          Added "expiration date" and "status" fields on booking migration type.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the bug on internal gift card purchases, whereby adding a promo code and removing it did not restore the value to the original amount.
        </li>
        <li>
          Removed the polyfill dependency to mitigate a supply chain security issue.
        </li>
        <li>
          Fixed the inconsistent scroll ar behavior on mobile booking site on page change and popups.
        </li>
        <li>
          Ensured that the location field on waiver populates the address in the customer company profile.
        </li>
        <li>
          Fixed the localization issue on zip/county labeling on company/company group settings pages.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(101)">September 27, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[101] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="default">inventory management</badge>
          Inventory management v1: ability to define inventory items and categories and apply them to a transaction on Transaction Details page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to define a custom deposit amount for payment requests.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Setting to show or hide custom amount field on payment requests.
        </li>
        <li>
          <badge type="warning">email</badge>
          Configuration option for gift card redemption button on Gift Card automated emails.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed price override bug preventing override when changing group count.
        </li>
        <li>
          Added the missing link to custom details page from booking list view.
        </li>
        <li>
          Fixed the bug on purchase report type preventing reports to generate without transaction id field selected.
        </li>
        <li>
          Ensured that a user's calendar settings are refreshed after a game is updated to correctly reflect the updated name.
        </li>
        <li>
          Added the missing mobile view on event logs.
        </li>
        <li>
          Fixed the bug on simple game tracker cause overwriting of group size.
        </li>
      </ul>
    </div>

    <h4  v-on:click="toggle(100)">September 20, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[100] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">reporting</badge>
          Date range setting on all report types.
        </li>
        <li>
          <badge type="warning">reporting</badge>
          New report type: Promo codes.
        </li>
        <li>
          <badge type="warning">reporting</badge>
          Added Tips field to Transactions report.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Granular booking activity log for each booking slot.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added "Not participating" and "Minor" tags to label the corresponding waivers on booking slots.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Added links to payment gateway documentation pages on Payment Settings for each of the supported gateways.
        </li>
        <li>
          <badge type="success">settings</badge>
          Ability to edit company name.
        </li>
        <li>
          <badge type="warning">email</badge>
          Email template for Refund events, automatically triggered when issuing a refund, if enabled.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Made sure to link active games to promo codes during migrations import.
        </li>
        <li>
          Fixed the bug where adding the first note to a booking on Transaction
          details view didn't mark the note as important and thus prevented it from being shown on booking list view.
        </li>
        <li>
          Fixed phone field placeholders to show the correct format for each of the supported locales on customer facing pages.
        </li>
        <li>
          Fixed the bug where blocked and call to book slots would be removed when updating a schedule, even when that option was not selected.
        </li>
        <li>
          Ensured that the calendar view on booking site correctly shows custom call to book text.
        </li>
        <li>
          Fixed confirmation and warning prompt text on list and calendar views when deleting a time slot or cancelling a booking.
        </li>
        <li>
          Fixed date picker value formatting on the page to edit schedules for date ranges.
        </li>
        <li>
          Fixed the issue on Transaction Invoice download where the phone number was a static value.
        </li>
        <li>
          Fixed the bug preventing automatic redirect on booking site for Stripe payments.
        </li>
        <li>
          Fixed the failed check of duplicate booking slots when migrating bookings.
        </li>
        <li>
          Ensured that the company address field correctly populates on email template previews.
        </li>
        <li>
          Added proper handling to Stripe transaction where payment amount is less than the supported minimum.
        </li>
        <li>
          Made it possible to generate Transaction reports without transaction id as a selected field.
        </li>
        <li>
          Fixed the bug where it was not possible to apply a promo code to transactions which did not have associated bookings.
        </li>
        <li>
          Fixed the bug on dynamic variables in the custom section of the Survey emails.
        </li>
        <li>
          Fixed the formatting bug automated email template incorrectly formatting ZAR currency, affecting the amount shown.
        </li>
      </ul>
    </div>


    <h4 v-on:click="toggle(99)">September 12, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[99] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Invoice download on transaction details page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to disable all payment options on booking site, forcing pay on arrival.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Added option to send gift card to purchasing customer when creating gift card internally.
        </li>
        <li>
          <badge type="success">games</badge>
          Ability to sort games on Game Settings, making it the default order on booking calendar.
        </li>
        <li>
          <badge type="success">games</badge>
          Escape rate statistic on Game Analytics page.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added a column showing available resources for a booking slot on booking list view.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Tag to indicate blocking behavior on resource slots.
        </li>
        <li>
          <badge type="success">photos</badge>
          Support for new dynamic variable on photo overlays: Time Remaining.
        </li>
        <li>
          <badge type="success">photos</badge>
          Feature to manage team name on Photos page.
        </li>
        <li>
          <badge type="warning">reporting</badge>
          Additional fields on Customer report type: Date joined and Date last visited.
        </li>
        <li>
          <badge type="warning">reporting</badge>
          Additional field on Purchases report type to show whether associated transaction has due amount.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Added non-participant tag to waiver section on Transaction details page.
        </li>
        <li>
          <badge type="danger">migrations</badge>
          Ability to import customer, booking, and transaction notes.
        </li>

      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Transaction links can now be opened in tabs rather rather than refreshing the current page.
        </li>
        <li>
          Made it possible to book booking slots that are blocked or have a game form attached to them.
        </li>
        <li>
          Relabeled Transaction Id field on reports for site-wide consistency.
        </li>
        <li>
          Fixed the bug in automated survey emails causing users to receive duplicate emails.
        </li>
        <li>
          Fixed the infinite load when switching groups while on game settings.
        </li>
        <li>
          Fixed the duplicate assignment of photos to bookings when a booking has a non-participant signed waiver.
        </li>
        <li>
          Ensured that game tracker properly saves team name when team consists of minors only.
        </li>
        <li>
          Ensured that a photo overlay scales correctly cross device.
        </li>
        <li>
          Fixed the bug on transaction details where cancelling edit booking removed the groups size from view.
        </li>
        <li>
          Improved the security of the cryptographic hash function when generating the file upload link for S3.
        </li>
        <li>
          Fixed the bug preventing the rating question type color on survey from being properly saved.
        </li>
        <li>
          Fixed the bug where the flag to set a promo code to internal only did not apply on promo code create.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(98)">September 5, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[98] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">email</badge>
          New email type: Cart abandonment.
        </li>
        <li>
          <badge type="success">hints</badge>
          Ability to preview screen in portrait mode on hint screen configuration page.
        </li>
        <li>
          <badge type="success">hints</badge>
          Added fit option for hint background image.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added booking slot idea on booking slot popups.
        </li>
        <li>
          <badge type="success">settings</badge>
          Updated the billing page to reflect the current pricing model.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Added support for deposits on custom payment types.
        </li>
        <li>
          <badge type="warning">reporting</badge>
          Added promo code field to Transactions report type.
        </li>
        <li>
          <badge type="success">photos</badge>
          Ability to sort photo overlay layers.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Increased the character limit on the checklist description field.
        </li>
        <li>
          Removed redundant links on the navbar.
        </li>
        <li>
          When changing group, ensured that navigation id is properly updated on all settings pages.
        </li>
        <li>
          Fixed the issue when another user switches group, it changed the group for all users.
        </li>
        <li>
          Added the missing ability to delete custom payment method on transaction details.
        </li>
        <li>
          Ensured that "Mark as Refund" option exists for Yappy and custom payment methods.
        </li>
        <li>
          Ensured that the booking confirmation email section order is consistent between setting and emails sent.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(97)">August 29, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[97] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Ability to add additional bookings to an existing transaction.
        </li>
        <li>
          <badge type="primary">primary</badge>
          Ability to add additional gift cards to an existing transaction.
        </li>
        <li>
          <badge type="primary">primary</badge>
          When a payment is collected internally, record the company user who took the payment.
        </li>
        <li>
          <badge type="success">customers</badge>
          On Games tab of the Customer Details page, added columns for notes, completion time, and hints.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Enabled autoscaling on photo overlays based on overlay settings reference point.
        </li>
        <li>
          Ensured that the option to send payment request is not hidden when choosing partial payments on internal bookings.
        </li>
        <li>
          Fixed waiver PDF download formatting site-wide.
        </li>
        <li>
          Ensured that conditional custom fields are correctly displayed on payment request page.
        </li>
        <li>
          Ensured that "Mark as Refund" option exists for Yappy and custom payment methods.
        </li>
        <li>
          Fixed RBAC inconsistencies on bookings page.
        </li>
        <li>
          Optimized clear cart cron job to prevent DB connection spikes.
        </li>
        <li>
          Added logic to cancel Stripe payment intent as soon as we receive a payment failure status to prevent confusion if payment intent status flips to success.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(96)">August 22, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[96] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">reporting</badge>
          Added new report type: "Payments"
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Override price feature modifies pricing category by type (flat or per person) rather than the booking subtotal.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the missing client-side permissions check on a set of features (delete waivers, cancel bookings, delete booking slots etc).
        </li>
        <li>
          Made it so user lands on a 401 page without logging out when trying to access an unauthorized page.
        </li>
        <li>
          Fixed the bug where updating a booking slot with a game form attached would set it back to 'Available'.
        </li>
        <li>
          Ensured that optional taxes and fees persist on the transaction when a booking or item is updated. Similarly, ensured that waived taxes and fees do not reappear.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(95)">August 15, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[95] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Cart abandonment section, listing abandoned and active carts.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Support for AUD and NDZ currencies.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added granularity to booking slot event logging.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Added missed dynamic CSS on the label for "Not participating" field on waivers.
        </li>
        <li>
          Fixed the issue where custom field setting didn't save correctly when choosing to appear only when Gift Card is in cart.
        </li>
        <li>
          Fixed the bug where promo codes did not calculate correctly when required deposits were enabled.
        </li>
        <li>
          Updated string comparison logic to allow for dynamic variables of photo overlays to be surrounded by arbitrary text.
        </li>
        <li>
          Ensured that Transactions CSV download contained data with filters applied.
        </li>
        <li>
          Added "Mark as Paid" button on payments for mobile views.
        </li>
        <li>
          Ensured that reminder email doesn't trigger for pending and cancelled transactions.
        </li>
        <li>
          Fixed the issue on Stripe payments where waived taxes and fees option was not respected.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(94)">August 8, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[94] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Additional actions to bulk update booking slots: change minimum booking notice and change maximum time to book.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Bulk action dates set to mirror the current calendars date.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          On custom fields policy popup, when a customer agrees to the policy, the field checkbox will be automatically checked.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Setting to show or hide company logo on the booking site.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Setting to show or hide pricing rate label on the booking site.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          When reschedulng a booking, ensured that existing waivers are retained from the target booking slot.
        </li>
        <li>
          Fixed word wrapping on gift card table and on customer details page.
        </li>
        <li>
          Removed prepopulated end time when creating a new booking slot.
        </li>
        <li>
          Made the calendar view window dynamically adjust to the height of the screen.
        </li>
        <li>
          Fixed missing internationalization labels on the booking site.
        </li>
        <li>
          Fixed double submit when adding a payment on calendar view.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(93)">August 2, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[93] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">customer portal</badge>
          Support for French and Spanish locales on customer facing pages: Waivers, Bookings, Payments requests, Surveys, and Emails
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Added promo code field to the internal Purchase Gift Cards feature.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Added preset gift card values and values per game on internal gift card purchases.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Updated payment request page to list items, gift cards, taxes, fees, and tips of a transaction.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Ability to assign a company user to a booking slot.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Converted the payment options radio inputs to dropdown on payment request page.
        </li>
        <li>
          Updated company settings address fields to be more consistent with company group settings by adding address line 2 and country.
        </li>
        <li>
          Fixed transaction timestamps on automated emails by taking into account the timezone of the company group.
        </li>
        <li>
          Removed redundant fields from game description on the customer facing booking page.
        </li>
        <li>
          Fixed the bug on schedules which prevented slots with extensive configurations such as dynamic pricing from being rendered.
        </li>
        <li>
          Fixed double submit on customer facing survey page.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(92)">July 25, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[92] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="info">waivers</badge>
          Configurable compact view option for the waiver page.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Kiosk mode for the waiver page.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Support for tipping on the booking site with pre-configured or arbitrary tipping option.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Ability to add or remove tips on transaction details page.
        </li>
        <li>
          <badge type="warning">email</badge>
          Customer email event log on transaction details and customer details pages.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Ensured that slot-specific custom pricing is not cleared on game settings update.
        </li>
        <li>
          Adjusted time zone setting on the cron job to generate billing statements to ensure that it's in sync with our server time.
        </li>
        <li>
          Added validation on groups and games when creating a promo code.
        </li>
        <li>
          Ensured that survey emails can't be sent without an active email template.
        </li>
        <li>
          Fixed the bug preventing custom pricing to be saved on schedule update.
        </li>
        <li>
          For transactions made with Paystack, ensured that we handle all possible payment statuses, including pending ones.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(91)">July 18, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[91] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Dynamic pricing allowing users to define pricing model for individual booking slots. Available on booking calendar and schedules.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added a confirmation prompt before moving or resizing a booking slot if that slot has an associate transaction.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added a confirmation prompt on calendar view when cancelling a booking.
        </li>

      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Ensured that the color configuration fields store and display color transparency.
        </li>
        <li>
          Ensured that cancelling a booking with failed payment is appropriately reflected in the email.
        </li>
        <li>
          On internal bookings, fixed the bug where applying a flat value promo code resulted in a negative amount in subtotal was greater that the promo code value.
        </li>
        <li>
          Fixed the issue a user's calendar setting would not update after a game has been added or removed.
        </li>
        <li>
          Ensured that the total transaction group size is taken into account when recalculating taxes and fees after updating a single booking.
        </li>
        <li>
          For transactions made with Paystack, made sure that tickets linked to a booking are properly cleared when a transaction fails to fullfill.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(90)">July 11, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[90] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">migrations</badge>
          Added error log to show which records have not been imported during any given upload.
        </li>
        <li>
          <badge type="danger">migrations</badge>
          Added a column to show duplicate records in an upload.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Database upgrade to improve overall performance.
        </li>
        <li>
          Updated the Migrations feature to be available as a pro serv.
        </li>
        <li>
          Added reserved concurrency limit to Migrations batch job for better database performance.
        </li>
        <li>
          Addressed batch job function timeouts on Migrations when handling large files.
        </li>
        <li>
          Added an intermediary step on Migrations where files are
          uploaded to S3 first in order to bypass the API Gateway 10mb payload size limitation.
        </li>
        <li>
          On Billing page, show currency as USD, not local currency defined by company.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(89)">July 4, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[89] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">billing</badge>
          Added restrictions on application content based on company plan.
        </li>
        <li>
          <badge type="warning">billing</badge>
          Implemented the finalized pricing model.
        </li>
        <li>
          <badge type="default">customers</badge>
          New fields to track when a customer first interacted with a company and the time of most recent interaction.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Changed Unauthorized error behavior throughout the application, resulting in redirect to profile rather than a logout.
        </li>
        <li>
          Ensured that the billing plan feature status is correctly carried over to the subsequent month.
        </li>
        <li>
          Ensured that an initial billing statement is created on company account creation.
        </li>
        <li>
          Fixed the bug resulting from improper handling of NULL customer name values on transaction details page.
        </li>
        <li>
          Ensured that the birthday field is being populated on internal customer profile when waiver is signed, even when that user already has a record without a birthday given.
        </li>
        <li>
          When a customer signs a waiver, ensured that company customer fields are updated if they have not been previously set.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(88)">June 27, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[88] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="default">customers</badge>
          Ability to add notes to customer details page.
        </li>
        <li>
          <badge type="warning">resource management</badge>
          Auto-blocking prompt when editing a booking slot or time slot on calendar and list view.
        </li>
        <li>
          <badge type="success">reports</badge>
          Customer Credit column on Customers report.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the error on dragging on resizing a resource slot on calendar view.
        </li>
        <li>
          Relaxed field validation on Authorized.net CVV field to support 4 digit codes.
        </li>
        <li>
          Pagination on CSV downloads to avoid errors when response is large.
        </li>
        <li>
          Additional server-side validation to prevent duplication of event when updating calendar settings.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(87)">June 20, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[87] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="default">customers</badge>
          Displaying gift cards purchased by customer on Customer Details page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Support for partial payments with gift cards on booking site.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Persistent booking page settings, which apply cross-device for any given user account.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added currency and amount to GA success event type.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Added force page refresh on cart expiry.
        </li>
        <li>
          Fixed gift card code generation routine to make it consistently 16 digits.
        </li>
        <li>
          Fixed the bug on calendar view preventing booking slots from being edited when they roll over to the next day.
        </li>
        <li>
          When reassigning a waiver to a different booking slot, ensuring that the team link from previous slot is properly cleared.
        </li>
        <li>
          Added the ability to change the order Yappy as a payment method.
        </li>
        <li>
          Increased SES quotas.
        </li>
        <li>
          Fixed the bug where updating bookings on a transaction didn't take into account existing cancelled bookings on the same transaction.
        </li>
        <li>
          On schedule update/create, made sure we're not passing NULL values as slot text whenever slot text is not defined.
        </li>
        <li>
          Fixed RBAC access issue on create custom reports.
        </li>
        <li>
          Fixed RBAC access issue on booking pages (customer search endpoint).
        </li>
        <li>
          Modified reports such they generate for company at large and added group column and filters.
        </li>
        <li>
          Added mobile view for user roles page.
        </li>
        <li>
          Fixed access to leaderboards with only view leaderboard permissions enabled.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(86)">June 13, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[86] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">emails</badge>
          Set up backend flows to track automated email events such as delivery, bounce, opening etc.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Updated the rate label on flat game pricing.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          On Promo Code Settings, ability to disable promo code field entirely.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to customize placeholder label for the promo code field.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added date toggle buttons on bookings list view.
        </li>
        <li>
          <badge type="danger">migrations</badge>
          Updated recommendation text on Migrations page.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Ability to edit "Participation status" on Waivers.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the site-wide side panel/content overlap.
        </li>
        <li>
          Prevented the data refresh on booking calendar from changing the scroll position of the page.
        </li>
        <li>
          Fixed the time conversion bug on calendar booking update.
        </li>
        <li>
          Fixed the typo in field name of the permissions table, causing permission check to fail.
        </li>
        <li>
          Fixed the bug where user management list didn't show the full list of users on load.
        </li>
        <li>
          Fixed the timezone date adjustment on Transaction dashboard for certain timezones.
        </li>
        <li>
          When a customer books concurrent events with autoblocking enabled, make sure to unblock the entire cart after failing the transaction.
        </li>
        <li>
          Made sure that Gift Cards can be applied cross-group when doing internal bookings.
        </li>
        <li>
          Fixed javascript rounding error on discounts.
        </li>
        <li>
          Fixed photo upload issue on Simple game tracker.
        </li>
        <li>
          Added mobile view for user roles page.
        </li>
        <li>
          Fixed access to leaderboards with only view leaderboard permissions enabled.
        </li>
      </ul>
    </div>



    <h4 v-on:click="toggle(85)">June 6, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[85] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">settings</badge>
          Account billing page, allowing users to update their plans and billing information, and view invoices.
        </li>
        <li>
          <badge type="warning">general</badge>
          Application-wide utilization and cost tracking.
        </li>
        <li>
          <badge type="info">integrations</badge>
          Added a custom GA event on booking flow completion (when a customer lands on booking confirmation page).
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          On Edit Game, removed the legacy feature to update group.
        </li>
        <li>
          Added a check for cancelled transactions when showing customer payment request page.
        </li>
        <li>
          Removed the tax line items on gift cart purchases.
        </li>
        <li>
          Suppressing the Check In button on booking site if the only purchase is gift card.
        </li>
        <li>
          Fixed the bug which caused payments with customer credit to display incorrect values.
        </li>
        <li>
          Fixed the bug on updating bookings to correctly recalculate applied per person promo codes.
        </li>
        <li>
          For cancelled bookings, ensured that the customer email shows correct payment status if no payment has been made.
        </li>
        <li>
          When cancelling a booking, ensured that items attached to transaction do not get removed from transaction due amount.
        </li>
        <li>
          Fixed the issue causing Game Tracker time widgets to not update on certain devices.
        </li>
        <li>
          Fixed the compound tax bug on internal bookings.
        </li>
        <li>
          Fixed the timezone bug on date filters on transactions, reports, and dashboards.
        </li>
        <li>
          Upgraded mail server API to circumvent the size limit imposed on email attachments, preventing some customer photos from being successfully delivered.
        </li>
        <li>
          Fixed the bug on cart expiry function, causing failure to clear some carts.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(84)">May 30, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[84] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">settings</badge>
          Ability to define custom user roles and role based access control.
        </li>
        <li>
          <badge type="success">settings</badge>
          Ability to configure email notification settings for internal users.
        </li>
        <li>
          <badge type="success">settings</badge>
          Platform activity log.
        </li>
        <li>
          <badge type="warning">general</badge>
          Persistent filters across the platform (filter states remain after page refresh).
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the date increment bug on the function to generate schedule slots.
        </li>
        <li>
          Fixed the bug on Yappy integration where bookings were being unblocked on valid transactions.
        </li>
        <li>
          For Yappy integration, fixed the order of resource blocking during booking flow.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(83)">May 23, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[83] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Ability to configure custom payment methods.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Mobile optimization for payment settings.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          "In Cart" timeout setting.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Updated Paystack validation flow.
        </li>
        <li>
          Fixed inconsistent loading of Square form on Payment Request page.
        </li>
        <li>
          Performed database maintenance and enhancements.
        </li>
        <li>
          Ensured that promo code usage does not increment when a transaction fails.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(82)">May 16, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[82] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Customizable global default call to book text field on booking site settings, (acts as fallback if slot-level call to book text is empty).
        </li>
        <li>
          <badge type="info">waivers</badge>
          Minor label on waivers listed under transaction details.
        </li>
        <li>
          <badge type="success">settings</badge>
          Nickname field on company user profile.
        </li>
        <li>
          <badge type="warning">emails</badge>
          Updated dynamic variables on follow up, photo, and survey email templates to support game master first name, last name, and nickname.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Prevented double counting on team members as displayed on leaderboards.
        </li>
        <li>
          Ensured that filter states are preserved through auto refresh on waiver history.
        </li>
        <li>
          For Yappy integration, ensured that partial amounts/deposits are passed correctly to the payment gateway.
        </li>
        <li>
          Ensured that promo code usage does not increment when a transaction fails.
        </li>
        <li>
          Fixed the bug causing infinite loading screen on the preview page of the game tracker.
        </li>
        <li>
          On internal booking calendar, made sure that slot settings display the actual value as opposed to placeholder value.
        </li>
        <li>
          On the customer facing link to purchase gift cards only, made sure that the option to compute value for game pulls the list of active games.
        </li>
        <li>
          When editing a booking slot, changing the game linked to the slot should set the group size to 0 and force the user to set the new group size.
        </li>
        <li>
          Added first name, last name, birthday and phone fields to waivers rather than pulling from customer information. This was done to avoid updates to end user profile while still retaining user-supplied data via waiver.
        </li>
        <li>
          Fixed styling on custom fields to better handle long dropdown options.
        </li>
        <li>
          Fixed the bug on the server side validation for min/max booking notice.
        </li>
        <li>
          Added postMessage events to GA4 tracking to ensure that the booking site can still send events when embedded through an iframe.
        </li>
        <li>
          Allowing 100% off promo codes.
        </li>
        <li>
          Fixed the bug where the setting to "Show Unnamed teams" on leaderboards wasn't correctly applied.
        </li>
        <li>
          Fixed the bug on user update on user management, which inadvertanly removed all group associations, removing the user from view.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(81)">May 9, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[81] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Support for booking rescheduling, in addition to time slot editing, on booking calendar and list view.
        </li>
        <li>
          <badge type="success">photos</badge>
          Added photos with overlays to customer details view as well as to customer accounts.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Support for 3 decimal places for percentage values on taxes and fees.
        </li>
        <li>
          <badge type="warning">general</badge>
          Database upgrade.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Ensured that company user list is complete on mobile.
        </li>
        <li>
          Modified CSS on custom fields such that bullet points entered into the rich text editor appear for any background.
        </li>
        <li>
          Preventing automatic calendar refresh from clearing data fields when booking modal is open.
        </li>
        <li>
          When constructing the Sign Waiver button in automated emails, handling the cases when a URL hash doesn't exist for waiver and redirecting to the main waiver page.
        </li>
        <li>
          With Stripe as the payment gateway, ensure that the submit button becomes freed up when selecting another payment method.
        </li>
        <li>
          Made sure that payment request payments aren't added to cancelled transactions.
        </li>
        <li>
          On internal bookings, moved promo field outside of Add Payment section to make it visible at all times.
        </li>
        <li>
          Handling cases when Add Payment is selected but no payment provided on internal bookings.
        </li>
        <li>
          Fixed the bug when clicking on a calendar slot and then dragging another slot falsely updated the dragged slot with the first customer name.
        </li>
        <li>
          When selecting a new game on booking (transaction details), made it so booking date and time fields clear and throw errors if left blank.
        </li>
        <li>
          Fixed the bug where the payment request page was not accepting full gift card amounts.
        </li>
        <li>
          Added pricing category cap validation to the booking site.
        </li>
        <li>
          Fixed the order of gift card validation before transaction update on internal payments.
        </li>
        <li>
          Ensured the the Square card element is properly refreshed when clicking out and into a payment modal.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(80)">May 3, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[80] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">photos</badge>
          Support for overlays on player photos. Ability to create custom overlays with optional dynamic variable and assign them to photos.
        </li>
        <li>
          <badge type="success">photos</badge>
          Photos with overlays to show on game history page.
        </li>
        <li>
          <badge type="success">photos</badge>
          Delivering photos with overlays in customer emails.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Custom expiration setting for payment requests, enabling users to define the time after a payment request is sent after which the transaction and associated booking will be cancelled.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to mark a card payment as refunded without processing the refund (useful for when a refund has already been processed via payment gateway).
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to override price on gift cards (internal only).
        </li>
        <li>
          <badge type="info">api</badge>
          Developer API. Customers can now use an API endpoint to pull their transactions data.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Adjusted CSS on disabled fields, making the values more visible.
        </li>
        <li>
          Added order number to gift card import on Migrations feature to be able to link gift cards to existing transactions.
        </li>
        <li>
          Made the activity log text more descriptive when processing a card refund as customer credit.
        </li>
        <li>
          Fixed the bug on the booking site where 100% discounts were not accepted.
        </li>
        <li>
          Fixed the birthday validation bug for minors' borthday field on waivers.
        </li>
        <li>
          On migrations, added handling of commas within a field to prevent errors during file import.
        </li>
        <li>
          On migrations, computing the "remaining" field to prevent discrepancies.
        </li>
        <li>
          When creating custom gift card codes internally, added an error to prevent multiple gift cards with the same code.
        </li>
        <li>
          Fixed the disjointed promo code field and button on booking site.
        </li>
        <li>
          Removed the note about file size cap on migration instructions section.
        </li>
        <li>
          When cancelling a transaction, ensured that associated taxes, fees, and promo records are deleted.
        </li>
        <li>
          When creating survey questions, ensured that saving one question does not remove in progress questions.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(79)">April 25, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[79] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Alert field on custom fields such that when enabled, it would expose customer response for that field on booking calendar slot.
        </li>
        <li>
          <badge type="success">surveys</badge>
          Additional game and game master columns on survey dashboard, whenever a survey is tied to a game.
        </li>
        <li>
          <badge type="success">surveys</badge>
          Additional filters on survey response dashboard (game, game master, date range).
        </li>
        <li>
          <badge type="success">surveys</badge>
          Dynamic question-based columns on survey responses that can be enable and disabled.
        </li>
        <li>
          <badge type="success">surveys</badge>
          Downloadable QR code link on surveys.
        </li>
        <li>
          <badge type="warning">email</badge>
          Support for Game Master dynamic variable on applicable automated emails, filling in the name of the person who ran the game tied to the email.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Default number of players field on game pricing, used to populate the default number of people when customer selects game on the booking page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Download feature on promo codes.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Configurable checkbox on waivers to track whether person signing on behalf of minors is participating in the event.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Internal label on waivers and game history to track non-participants tied to an event.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Added validation on birthday field on waivers.
        </li>
        <li>
          Fixed timestamp timezone conversion across the entire application, which caused inaccurate dashboard reporting and filter results.
        </li>
        <li>
          Fixed the bug where the game image on waiver link would appear despite being set as not visible to customers.
        </li>
        <li>
          Added check for allowing deposit before enforcing the setting for required deposit.
        </li>
        <li>
          Added a routine for handling stale Stripe transactions.
        </li>
        <li>
          Ensured that cancelling a gift card on a cancelled transaction would not doubly adjust the total transaction values.
        </li>
        <li>
          Removed pending transactions from showing on the booking calendar.
        </li>
        <li>
          Fixed the game analytics query to ignore puzzles marked as unsolved.
        </li>
        <li>
          Removed optional fees when making an internal gift card purchase.
        </li>
        <li>
          Modified the purchases report type to treat gift cards as payments.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(78)">April 18, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[78] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Setting for gift cards to include or exclude taxes and fees when calculating per game value during purchase.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Added optional taxes and fees, which will not be added on the booking site but can be added to transactions internally.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added multi-select option on status and game filter on booking list view.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          "In cart" label on bookings list and calendar view tracking when a booking slot is in customer's cart.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Setting to hide or show schedule name label on booking list and calendar view.
        </li>
        <li>
          <badge type="success">surveys</badge>
          Added game and game master columns on survey responses table, tracking which game the survey was a follow up of, as applicable.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Removed puzzle completion limit when querying data for the game analytics page to show accurate results.
        </li>
        <li>
          Fixed the issue on booking site where a gift card would be factored into the deposit when in cart with a deposit-enabled game.
        </li>
        <li>
          Added handling for date conversion across time picker widgets on the application to prevent inaccurate dates when choosing time.
        </li>
        <li>
          Fixed the scroll bar break on internal cart page.
        </li>
        <li>
          On customer-facing waivers, ensured that the "Country" label is shown for all locales except US.
        </li>
        <li>
          Ensured that filters appear properly for small screens on the booking list view.
        </li>
        <li>
          Fixed the bug on booking site where the gift card panel wrongly appeared instead of game description panel when using the progress bar to navigate,
        </li>
        <li>
          Added sanitization on spaces for internal gift card lookup, such that spaces are ignored when typing in gift card code.
        </li>
        <li>
          Fixed the issue where changing the game settings didn't update the booking calendar setting cache, causing breaks in the booking flow.
        </li>
        <li>
          Fixed the bug scoped to Stripe users where deposit values weren't correctly applied to card payments.
        </li>
        <li>
          Fixed the Payment filter on Transactions list to show negative and positive amounts due.
        </li>
        <li>
          Fixed the bug where adding taxes manually on transaction details page ignored the tax value type.
        </li>
        <li>
          Ensured that booking site settings regarding field visibility of groups size, difficulty, and duration also applied on the game description page.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(77)">April 11, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[77] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Ability to control placement of game details (difficulty rating, group size, title, duration) on the booking site.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Bulk update feature on the booking list and calendar view, allowing users to mass update booking slot status.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Individual booking site pages for each company event as well as gift cards.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Configuration to make custom fields appear conditionally, for example when a certain item is in cart.
        </li>
        <li>
          <badge type="warning">general</badge>
          Persisting booking page settings after logging in and out.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Label for internal only promo codes on the promo code list.
        </li>
        <li>
          <badge type="success">surveys</badge>
          Survey analytics page, showing the breakdown of survey responses.
        </li>
        <li>
          <badge type="success">surveys</badge>
          Link to the customer facing survey page from Edit Survey page.
        </li>
        <li>
          <badge type="success">surveys</badge>
          Expose a customer's survey responses on customer details page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the wrap formatting of long line items in booking confirmation pdf invoices.
        </li>
        <li>
          Added sanitization on the customer lookup's phone field to ignore special characters.
        </li>
        <li>
          Joined customer first and last name, making it possible to seach for both at the same time.
        </li>
        <li>
          Fixed the bug where a flat tax would not be ignored for gift card purchases.
        </li>
        <li>
          Ensured that users get an error message for failed Stripe payments.
        </li>
        <li>
          Added the fail flag to failed payments in Stripe.
        </li>
        <li>
          Remove failed transaction link for bookings with failed stripe transactions attached.
        </li>
        <li>
          Fixed the issue where cumulative pricing for 0 participants counted toward the total price.
        </li>
        <li>
          Fixed the order of checkbox and dropdown items on survey.
        </li>
        <li>
          Rearranged customer data fields on the survey page.
        </li>
        <li>
          Removed the overlapping search icon on user settings.
        </li>
        <li>
          Added server side validation on the email field when customer makes a booking, rejecting empty and invalid emails.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(76)">April 4, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[76] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Cumulative pricing category option for game pricing.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added additional custom fonts to booking site and waiver settings.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added booking collision check when making internal bookings.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Option to configure promo codes to be only applicable internally.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Reimplemented the order number algorithm for transactions.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the reactivity issue preventing back to back creation of time slots on booking list view.
        </li>
        <li>
          Improved text fit of the custom call to book text on the booking site by changing the overflow wrapping setting.
        </li>
        <li>
          Remove color change on hover for custom links on the booking site and waivers.
        </li>
        <li>
          Allowing blank birthday values on data migration.
        </li>
        <li>
          Fixed the issue where a blank user last name prevented the transaction details from rendering.
        </li>
        <li>
          Fixed the issue occurring when creating or editing a closed period without games attached to the schedule.
        </li>
        <li>
          Added the missing group dropdown field on the mobile view.
        </li>
        <li>
          Fixed the Preview email feature on email template list view.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(75)">March 28, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[75] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">email</badge>
          Ability to configure custom email domain for automated emails.
        </li>
        <li>
          <badge type="warning">email</badge>
          Update to the automated email settings UI, including a new General Settings tab.
        </li>
        <li>
          <badge type="warning">email</badge>
          Changed default from email from info@offthecouch.io to noreply@offthecouch.io.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Overhauled the 'Add players' tab to be more consistent with the feature to edit booking on Transaction Details page.
        </li>
        <li>
          <badge type="success">customer details</badge>
          Added child waiver (as applicable) to customer details page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Implemented mobile-optimized view for transaction details page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Converted gift card type from discount to payment, updating payment features throughout the application.
        </li>
        <li>
          <badge type="default">migration</badge>
          Added support for additional fields on Transaction migration type: timestamp, status, and discount.
        </li>
        <li>
          <badge type="default">migration</badge>
          Implemented additional validation and sanitization on file imports for more seamless uploads, e.g. removing case sensitivity on statuses.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the stacking of buttons on the Custom Fields tables by converting it to a dropdown.
        </li>
        <li>
          Removed the check preventing the first child to be removed on customer waivers.
        </li>
        <li>
          On migration uploads, added the function to convert payload into batches to prevent timeouts for larger data sets.
        </li>
        <li>
          Fixed the bug where pricing categories didn't add up to the correct subtotal when the quantity was set to less than the pricing defined for a particular game.
        </li>
        <li>
          Mitigated the security issue where it was possible to append "pay_on_arrival" parameter to bypass payment requirements on cart even when pay on arrival setting was not enabled.
        </li>
        <li>
          Disabled the ability to update a schedule while schedule slot creation is in progress to avoid unintended duplicate slots.
        </li>
        <li>
          Set the category pricing ranges on the booking site to default to the minimum number for that range as defined in settings.
        </li>
        <li>
          Fixed the legacy issue where game tracker settings id was pulled from local storage rather than URL query, causing users to log out.
        </li>
        <li>
          Changed the success message when archiving/unarchiving a game.
        </li>
        <li>
          Fixed the bug where updating a resource schedule slot with more resources than games blocks off slots incorrectly.
        </li>
        <li>
          Fixed the bug resulting from gift card type conversion causing disruption to automated emails.
        </li>
        <li>
          Added dynamic labeling on cardholder name on the booking site depending if card of gift card payment type is selected.
        </li>
        <li>
          Fixed the oversight of not checking for ZAR when selecting currency symbol in automated email templates.
        </li>
        <li>
          Applied dynamic CSS to payment options radio buttons on payment request page.
        </li>
        <li>
          When creating migration records for waivers or booking slots, added a check for duplicates.
        </li>
        <li>
          Fixed the reactivity issue on the UI preventing user from uploading a file immediately after a failed upload on migrations.
        </li>
        <li>
          Implemented an asynchronous function for purging migration records to avoid interrupts due to timeout.
        </li>
        <li>
          Fixed the issue on automated emails where company emails did were not delivered to all company users due to the use of BCC.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(74)">March 21, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[74] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge> <badge type="info ml-1">waivers</badge>
          Added an improved booking and waiver embedding code snippet that can adjust the size of the embedded frame base on loaded content to avoid double scroll bars.
        </li>
        <li>
          <badge type="success">localization</badge>
          Added support for Canadian dollars.
        </li>
        <li>
          <badge type="primary">customer details</badge> <badge type="default ml-1">migration</badge>
          Exposed marketing opt in fields on the customer details page and added them as supported fields on migrations feature.
        </li>
        <li>
          <badge type="default">migration</badge>
          Added a best practices section on the migration page.
        </li>
        <li>
          <badge type="default">migration</badge>
          When processing CSV files on the migration feature, added sanitization on header fields.
        </li>
        <li>
          <badge type="default">migration</badge>
          Added more descriptive error messaging and logging on migration failure.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed formatting issues appearing for certain currency localization settings.
        </li>
        <li>
          Removed duplicate Location field on waiver settings and addressed the root cause of the duplication.
        </li>
        <li>
          Fixed error message when applying customer credit.
        </li>
        <li>
          Fixed the lag on the checked in players dropdown on booking list view causing the list to not appear when navigating to a new date.
        </li>
        <li>
          On transaction details page, ensured that taxes are correctly recomputed after applying discounts.
        </li>
        <li>
          On transaction details page, ensured that taxes and due amount are correctly recomputed after updating a booking.
        </li>
        <li>
          On transaction details page, ensured applied promo codes are correctly recalculated when adding, editing, or deleting an item on the transaction.
        </li>
        <li>
          Fixed the legacy issue where game tracker settings id was pulled from local storage rather than URL query, causing users to log out.
        </li>
        <li>
          Changed the success message when archiving/unarchiving a game.
        </li>
        <li>
          Fixed the bug where updating a resource schedule slot with more resources than games blocks off slots incorrectly.
        </li>
        <li>
          Change the Stripe payment failure flow to retain and suppress failed transactions, rather than deleting them.
        </li>
        <li>
          Fixed the bug preventing users to check in with minors via the waiver link.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(73)">March 14, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[73] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">email</badge>
          Automated email type for surveys.
        </li>
        <li>
          <badge type="success">surveys</badge>
          Ability to send surveys to players, either by searching customers directly or by looking up bookings or games.
        </li>
        <li>
          <badge type="warning">email</badge>
          Updated all automated emails to a new CSS template and ensured that the preview feature matches the outgoing emails.
        </li>
        <li>
          <badge type="warning">email</badge>
          Added the option to send waiver link to booking reminder and updated booking emails.
        </li>
        <li>
          <badge type="primary">schedules</badge>
          Added a real-time progress bar to indicate completion status for creating booking slots when updating or creating a schedule.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Added the ability to delete child rows on customer waivers.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Implemented the workaround for pulling up the camera on Android phones.
        </li>
        <li>
          Added missing address fields on the footer of all automated emails.
        </li>
        <li>
          Improved color contrast of the dropdown text on the transaction details page.
        </li>
        <li>
          Fixed the bug where updating a schedule incorrectly blocked off available slots for the day of week a booking existed.
        </li>
        <li>
          Ensured that the settings page is correctly loaded and populated upon login.
        </li>
        <li>
          Fixed the transaction activity record formatting when issuing a refund with Authorize.net.
        </li>
        <li>
          Validation to prevent users from submitting $0 payments on transaction details page.
        </li>
        <li>
          Fixed the broken link on the feature to copy hint screen url on automated hint configuration page.
        </li>
        <li>
          Implemented a condition to ensure that waiver link is not included in emails if the waiver site is deactivated.
        </li>
        <li>
          Fixed decimal formatting on Authorize.net transactions.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(72)">March 6, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[72] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">payments</badge>
          Implemented Yappy integration for processing payments.
        </li>
        <li>
          <badge type="danger">booking site</badge> <badge class="ml-2" type="info">waivers</badge>
          Added the ability to set color for links appearing on booking site, payment request page, and waiver.
        </li>
        <li>
          <badge type="warning">migration</badge>
          Create an asyncronous back-end import function to process large sets of data.
        </li>
        <li>
          <badge type="warning">migration</badge>
          Added a progress bar, completion and duplicate count to the migrations log.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Added near-real time updates on the waiver history page to prevent stale data.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the issue preventing back-to-back file uploads on the data migrations page.
        </li>
        <li>
          Fixed styles on booking site and waiver pages such that all widgets take on custom CSS rather than the default color scheme.
          This includes checkboxes, placeholder text, dropdowns, and modals.
        </li>
        <li>
          Added sanitization for /r/n characters to support migration from CSV files generated on Windows systems.
        </li>
        <li>
          Fixed the bug on Stripe payments where the total charged to Stripe failed to account for added promo codes.
        </li>
        <li>
          Fixed the bug preventing updates of the end date on game history form.
        </li>
        <li>
          Removed redundant group list pages on all settings pages, leaving the user to toggle from the nav bar instead.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(71)">February 29, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[71] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">migration</badge>
          Added data migration feature, supporting csv imports for the following data types: customers, waivers, booking slots, transactions, promo codes, gift cards, and customer credit.
        </li>
        <li>
          <badge type="info">surveys</badge>
          Added the feature to create and configure surveys, including the ability to define question and responses types (checkboxes, dropdowns, inputs, rating).
        </li>
        <li>
          <badge type="info">surveys</badge>
          Implemented the customer-facing survey page, hosting the survey form.
        </li>
        <li>
          <badge type="info">surveys</badge>
          Added the page to display survey response history and a page showing all responses for a submitted survey.
        </li>
        <li>
          <badge type="success">hints</badge>
          Added the option to put the background music for the hint system on loop.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Preventing the weekly view on the booking site from showing past slots and ensuring it shows the correct label for call to book slots.
        </li>
        <li>
          Updated the messaging on activity log for customer credit refunds for more clarity.
        </li>
        <li>
          Fixed the bug preventing back-to-back file uploads on the hint system's background music setup.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(70)">February 21, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[70] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Configurable error message on the booking site to prevent a customer from booking games when there are insufficient resources to run them.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Exposed min/max notice window and call to book text fields on each of the time slots on calendar and list view, such that they can be modified on a slot by slot basis.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Ability to adjust a booking slot on the calendar view by dragging or resizing the event box.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added waiver count and the names of the checked-in players with links to player details on the bookings page (list and calendar).
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Relabeled the button "complete booking" to "make a payment" when the payment gateway is Paystack.
        </li>
        <li>
          <badge type="info">integrations</badge>
          GA4 integration.
        </li>
        <li>
          <badge type="info">integrations</badge>
          Google Tag Manager integration.
        </li>
        <li>
          <badge type="info">integrations</badge>
          Meta Pixel integration.
        </li>
        <li>
          <badge type="success">waivers</badge>
          Added the options to delete and edit waivers on transaction details page.
        </li>
        <li>
          <badge type="default">customer details</badge>
          Grouping custom field responses by transaction.
        </li>
        <li>
          <badge type="primary">checklists</badge>
          Ability to edit start and end time on a completed checklist (admin and manager only).
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Resolved the issue where setting the min notice didn't affect the current day.
        </li>
        <li>
          Ensured that all games for a group appear on the company settings page.
        </li>
        <li>
          Fixed birthday field format on transactions details > waivers tab.
        </li>
        <li>
          Fixed the issue where the booking calendar didn't update when switching the group.
        </li>
        <li>
          Resolved the bug breaking booking site cart whenever a game did not have an associated image.
        </li>
        <li>
          Fixed variable reactivity issue on the customer credit tab (customer details page).
        </li>
        <li>
          Addressed the discrepancy between selected and visible games on the booking calendar on mobile devices.
        </li>
        <li>
          Fixed the infinite loader on game analytics in absence of game data.
        </li>
        <li>
          Fixed the issue where you could not add a note on a transaction that was missing a booking.
        </li>
        <li>
          Cleaned up the visual display of difficulty icons on the mobile view of the booking site.
        </li>
        <li>
          Fixed the time zones file to track by id rather than abbreviation.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(69)">February 14, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[69] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="info">security</badge>
          Upgrade the server runtime environment to Node 20.x.
        </li>
        <li>
          <badge type="info">security</badge>
          Set up a database proxy to improve database security and performance.
        </li>
        <li>
          <badge type="info">security</badge>
          Set up a secrets manager for increased server-side security.
        </li>
        <li>
          <badge type="info">performance</badge>
          Increased server-side memory for performance optimization.
        </li>
        <li>
          <badge type="warning">general</badge>
          Added grouping labels to AWS resources.
        </li>
        <li>
          <badge type="danger">payments</badge>
          Set up integration with Paystack and added Paystack form throughout the site.
        </li>
        <li>
          <badge type="success">localization</badge>
          Added South African Rand as a supported currency throughout the site.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Removed duplicated setting form fields on create schedule's bulk update feature.
        </li>
        <li>
          Fixed the issue where creating slots spanning multiple days on schedule showed incorrect the end time.
        </li>
        <li>
          On schedules, when auto-generating time slots, fixed the issue where min/max notice fields where set with hard-coded values.
        </li>
        <li>
          Added the missing link fields on popup modal on create schedule.
        </li>
        <li>
          On booking lis view, added the missing option to create resource time slot on mobile view.
        </li>
        <li>
          Re-added the error message when making a payment for more than the amount due.
        </li>
        <li>
          Removed archived group from being listed on game tracker settings.
        </li>
        <li>
          Standardized the warning popup across the site.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(68)">February 7, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[68] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">schedules</badge>
          Ability to enable or disable auto-blocking on a resource schedule.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Added the option to auto-block slots with the status "Call to book".
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Auto-block check when creating, editing, or activating a booking schedule.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Auto-block check when creating or editing a booking slot.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Added a button to bulk update schedule settings.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Updated booking slots on the booking site such that the call to book settings are pulled from slot settings rather than global settings (legacy).
        </li>
        <li>
          <badge type="warning">authentication and authorization</badge>
          Added a note in the company user invitation email about temporary password expiration.
        </li>
        <li>
          <badge type="warning">authentication and authorization</badge>
          Expanded the game master role to include access to the waiver history page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the automated hints timer such that you don't need to pause and reset it before it can start after overriding the value.
        </li>
        <li>
          Fixed the reactivity lag on taxes and fees update on calendar view.
        </li>
        <li>
          For the resource schedules section to "help generate slots", removed gap duration option.
        </li>
        <li>
          Fixed the conditional logic when adding up pricing categories for cases where the number of player is less than defined in game settings.
        </li>
        <li>
          Fixed the issue when profile data doesn't immediately populate upon first login.
        </li>
        <li>
          Added validation to prevent schedule slot creation for past dates.
        </li>
        <li>
          Fixed the sorting of days on schedule list page.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(67)">January 31, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[67] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">automated hints</badge>
          Ability to set background music.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Near real-time updates on the internal booking calendar (calendar and list view).
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Set up a cron job to automatically generate recurring time slots for resource schedules.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Automatically blocking slots when a resource schedule is defined and no resources are available.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Added informational text defining schedule priority model.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          When setting up a schedule template, enabled the calendar to auto-adjust the time range based on the tme slots created.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Added total fields on the customer credit tab (customer details page).
        </li>
        <li>
          <badge type="primary">purchases</badge>
          On custom field answers (additional fields on the transaction details page), added policy links.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Modified the number of resources setting to apply on a per-slot rather than per-schedule basis.
        </li>
        <li>
          Fixed the time format issue on schedules when localization was set to 12-hr time.
        </li>
        <li>
          Fixed the bug where you couldn't delete a resource schedule without deactivating it first.
        </li>
        <li>
          Removed blocked and unavailable statuses from schedule template.
        </li>
        <li>
          Removed min/max notice fields from resource schedule type template.
        </li>
        <li>
          Made archived games hidden by default.
        </li>
        <li>
          Modified the existing booking slot generating cron job to support changes to schedules.
        </li>
        <li>
          Fixed the issue where overriding subtotal to $0 on internal booking did not correctly compute taxes and fees.
        </li>
        <li>
          Fixed unwanted special character encoding in automated emails.
        </li>
        <li>
          Addressed the bug on customer credit refunds.
        </li>
        <li>
          Fixed the incorrect timestamp value on customer credits when issuing a refund.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(66)">January 25, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[66] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">schedules</badge>
          Replaced the schedule slot component with a calendar, for a better user experience creating, editing, moving, and resizing time slots and gaps.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Improved the schedule slot creation helper feature.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Added the ability to bulk create slots wither either "Available" or "Call to book" status.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Added a new schedule type for resource schedules, shown in a new tab on the schedules module.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Ability to activate or deactivate a schedule.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Added the option to create a schedule as active or inactive.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          When updating a schedule with the option to generate time slots, added the option to remove conflicting blocked and call to book slots.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Added mobile view for the schedule module.
        </li>
        <li>
          <badge type="danger">schedules</badge>
          Added support for creating schedule slots spanning multiple days.
        </li>
        <li>
          <badge type="success">games</badge>
          Added a link to a game's transaction details page from the game history page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Resolved the bug where schedule time slots sometimes displayed out of order.
        </li>
        <li>
          Removed global min/max time window setting on schedules in favor of a per-slot setting.
        </li>
        <li>
          Fixed the bug where setting the booking price to $0 did not recompute the taxes and fees based on the subtotal value.
        </li>
        <li>
          Added missing localization on the gift card purchases list.
        </li>
        <li>
          Removed policy pop-up shadow clone for custom fields.
        </li>
        <li>
          Fixed the double submit issue on the payment request page.
        </li>
        <li>
          Fixed the issue where missing min/max fields caused the creation of booking slots to interrupt.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(65)">January 17, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[65] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">games</badge>
          Optional game difficulty level.
        </li>
        <li>
          <badge type="success">games</badge>
          Customizable icons, label, and color for gift difficulty level.
        </li>
        <li>
          <badge type="success">games</badge>
          Option to make game deposit required.
        </li>
        <li>
          <badge type="success">games</badge>
          Removed the delete game button and replaced it with the feature to archive or unarchive a game.
        </li>
        <li>
          <badge type="warning">general</badge>
          Added mobile friendly view for transactions, customers, and gift card list pages.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Automatically refund funds to gift card when gift card payment is removed from a transaction.
        </li>
        <li>
          <badge type="warning">email</badge>
          Included gift cards as a payment type in automated emails.
        </li>
        <li>
          <badge type="warning">general</badge>
          Support for object fit options on the image editor widget.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the transaction status labels on CSV download for transaction report types.
        </li>
        <li>
          Changed the way gift cards apply to game deposits.
        </li>
        <li>
          Fixed the errors caused by custom dropdowns on the booking site.
        </li>
        <li>
          Suppressing customer credit payment option for customers with used up credit.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(64)">January 11, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[64] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Support for custom fields on the booking site, including checkboxes with external links or text popups, dropdowns with optional follow-up field, and standard input field.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Ability to allow customers to pay deposit for a game through the booking site and on the payment request page. Deposits can be configured per booking or per participant.
        </li>
        <li>
          <badge type="success">games</badge>
          Disable carousel arrows on image display whenever only one image is uploaded for a game. Otherwise, show arrows.
        </li>
        <li>
          <badge type="success">games</badge>
          Option to suppress uploaded game images from customer-facing pages.
        </li>
        <li>
          <badge type="success">games</badge>
          Ability to edit a game image.
        </li>
        <li>
          <badge type="warning">general</badge>
          Support for object fit options on the image editor widget.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Resolved the hint timer sync issue.
        </li>
        <li>
          Re-implemented the Stripe payment flow to prevent discrepancies when a customer payment fails.
        </li>
        <li>
          Fixed the issue where game information on the booking site was hidden behind the image carousel.
        </li>
        <li>
          Fixed image fit for ported over game images.
        </li>
        <li>
          Added backend validation for min/max time window on booking slots.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(63)">January 3, 2024
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[63] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">games</badge>
          Made the puzzle configuration table on edit and create game pages drag and drop.
        </li>
        <li>
          <badge type="success">games</badge>
          Replaced the game description field with a rich text editor.
        </li>
        <li>
          <badge type="success">games</badge>
          Added support for images as solution to puzzles. Uploaded images will be displayed on the hint panel and on advanced game tracker.
        </li>
        <li>
          <badge type="success">games</badge>
          Added support for multiple images per game. When multiple images are configured, they are displayed as a carousel.
        </li>
        <li>
          <badge type="warning">general</badge>
          Created a site-wide component to format uploaded images with scale, background color, and position parameters.
        </li>
        <li>
          <badge type="warning">general</badge>
          Added sharable links to transactions, game forms, games, and customers to allow for multiple pages open at the same time.
        </li>
        <li>
          <badge type="success">photos</badge>
          Added a banner on the photos page to indicate when the photos automated email is disabled.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added validation to prevent booked slots from being blocked.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added validation to on booking site to prevent a booking when game settings change.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the company setting form to allow for update of social links.
        </li>
        <li>
          Fixed the bug on duplicate handling when adding gift cards and promo codes on transaction details.
        </li>
        <li>
          Updated labels on booking list and calendar view for better internal consistency.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(62)">December 27, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[62] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="info">customer details</badge>
          Ability to open customer details in multiple tabs.
        </li>
        <li>
          <badge type="success">photos</badge>
          Support for more than one photo per bookings.
        </li>
        <li>
          <badge type="success">photos</badge>
          Ability to send a photo to an arbitrary player.
        </li>
        <li>
          <badge type="success">photos</badge>
          Added "Take photo" button on the simple game tracker.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Per person promo code type.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added due and paid columns on the booking list view.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Handling promo codes greater than cart value on internal purchases.
        </li>
        <li>
          Changed the order of cart summary such that discounts are listed before taxes and fees.
        </li>
        <li>
          Improved the mobile view of the customers details page.
        </li>
        <li>
          Cleaned up photo settings page to show settings for non-archived groups only as well as to change settings when the global group option is changed.
        </li>
        <li>
          Added custom items as line items on automated emails where applicable.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(61)">December 20, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[61] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="primary">purchases</badge>
          Added promo and gift card field on the payment request page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to create gift cards internally on gift purchases page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Support for custom (as opposed to auto-generated) gift card codes.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Ability to set a separate terms and services link on gift cards and optionally make it visible on the booking site.
        </li>
        <li>
          <badge type="success">reports</badge>
          Booking date field on Purchases report type for applicable purchases.
        </li>
        <li>
          <badge type="success">photos</badge>
          Ability to assign a photo any existing booking, rather than only bookings with completed game tracker form.
        </li>
        <li>
          <badge type="success">photos</badge>
          Full customer search on the feature to assign photo to players.
        </li>
        <li>
          <badge type="info">customers</badge>
          Customer lookup by phone.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Removed redundant API endpoint (/end-users)
        </li>
        <li>
          Fixed puzzle time since start computation on puzzle history page.
        </li>
        <li>
          On booking site, validating total group size (all pricing categories) again the maxiumum allowed group size for game.
        </li>
        <li>
          Fixed the issue where applying a promo code to the full cart amount prevented gift cards in cart from being created.
        </li>
        <li>
          Mitigated scenarios for negative cart values introduced by the new "Aplly after dicount" tax type.
        </li>
        <li>
          Added validation by company when a gift card is applied.
        </li>
        <li>
          Ensured that taxes and fees do not show up in confirmation emails if taxes or fees were waived.
        </li>
        <li>
          Fixed the cron job to generate booking slots for recurring schedules such that it iterates to the next available date, past scheduling conflicts and days without defined schedule slots.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(60)">December 13, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[60] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Label for how a booking slot was created (schedule name or manually created) on calendar and booking list view.
        </li>
        <li>
          <badge type="success">games</badge>
          Link to game history (when applicable) from transaction details page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Link on the "used" column of promo codes to transactions where that code was applied.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Download PDF button for gift card purchases.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Button to delete cash or POS payment on transaction details page.
        </li>
        <li>
          <badge type="primary">purchases</badge>
          Option to set a tax to apply before or after discounts.
        </li>
        <li>
          <badge type="success">reports</badge>
          Dynamic filters based on selected columns on generated reports.
        </li>
        <li>
          <badge type="success">reports</badge>
          Optional marketing fields on Customer report type.
        </li>
        <li>
          <badge type="success">reports</badge>
          "Purchases" report type (includes bookings, items, and gift card purchases).
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the bug where applying a promo code internally did not appear as a line item in confirmation emails.
        </li>
        <li>
          Centered image upload button on company settings page.
        </li>
        <li>
          Fixed the issue where the "Override price" fields didn't retain values on the transactions details page.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(59)">December 6, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[59] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Ability to reorder resource lanes on the booking calendar view.
        </li>
        <li>
          <badge type="success">reports</badge>
          Ability to create, edit, delete, and generate reports for Customers, Games, and Transactions.
        </li>
        <li>
          <badge type="success">reports</badge>
          Download CSV on a generated report.
        </li>
        <li>
          <badge type="success">reports</badge>
          Report activity log to track who and when generated a report.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Cancelling a booking or a transaction now retains any potential waiver record links associated with the cancelled slot.
        </li>
        <li>
          Added phone record to customer autocomplete search feature.
        </li>
        <li>
          Fixed the CSV download feature on Customers page.
        </li>
        <li>
          Preventing the block button from disappearing on the booking list view if the slot status is checked-in.
        </li>
        <li>
          Adjusted for timezones when calculating time since start for puzzles on game history page.
        </li>
        <li>
          Made it possible to create a schedule for the span of one day.
        </li>
        <li>
          Added checks on the booking site to prevent bookings of missing, removed, cancelled, completed, blocked, and expired slots.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(58)">November 29, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[58] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">automated emails</badge>
          Booking reminder emails settings and template.
        </li>
        <li>
          <badge type="warning">automated emails</badge>
          Follow up emails settings and template.
        </li>
        <li>
          <badge type="warning">automated emails</badge>
          Cron jobs to trigger scheduled emails according to settings.
        </li>
        <li>
          <badge type="warning">automated emails</badge>
          Option to not send a booking confirmation email when making a booking internally.
        </li>
        <li>
          <badge type="success">general</badge>
          Site-wide API error handling, proving feedback to user when the backend fails.
        </li>
        <li>
          <badge type="success">general</badge>
          Restructured side bar menu to separate out Bookings and Purchases.
        </li>
        <li>
          <badge type="info">purchases</badge>
          List of gift purchases, including filters and pagination.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Link to customer details from booking list and calendar view.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Setting to automatically redirect customers after completing a booking.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Ability to customize redirect button label.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the lack of handling negative cart values when adding promo codes.
        </li>
        <li>
          Reconfigured Lambda functions to prevent retries after timeouts.
        </li>
        <li>
          Fixed Stripe payment intent function.
        </li>
        <li>
          Cosmetic improvements to booking site.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(57)">November 23, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[57] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">gift cards</badge>
          Ability for customers to set a delivery date when purchasing gift cards.
        </li>
        <li>
          <badge type="success">gift cards</badge>
          Ability to apply promo codes to gift cards.
        </li>
        <li>
          <badge type="success">gift cards</badge>
          Accepting gift card payments on internal bookings and transaction details page.
        </li>
        <li>
          <badge type="success">gift cards</badge>
          Ability for customers to send gift cards to self.
        </li>
        <li>
          <badge type="success">gift cards</badge>
          Customizeable gift card policy header and rich text editor for policy text.
        </li>
        <li>
          <badge type="warning">automated emails</badge>
          Automated email settings for gift card delivery emails.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed frozen scroll bar when navigating to another page from a modal.
        </li>
        <li>
          On game tracker, fixed the issue where typing into (rather than selecting from) a time field set the wrong underlying date.
        </li>
        <li>
          Cleaned up the mobile view on the page to purchase gift cards.
        </li>
        <li>
          Dynamically recalculating promo codes applied to cart when adding or removing items from cart to prevent promo abuse.
        </li>
        <li>
          Handling remaining checklists for archived games.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(56)">November 17, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[56] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">gift cards</badge>
          Gift card recipient email to trigger on gift card purchase.
        </li>
        <li>
          <badge type="success">gift cards</badge>
          Updated booking confirmation email to include details about gift card purchases.
        </li>
        <li>
          <badge type="success">gift cards</badge>
          Added the ability to redeem gift cards on the booking site.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Included gift card purchase information on transaction details page.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Added the ability to cancel gift cards and promo codes on transaction details page.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Omitting taxes from gift card purchases.
        </li>
        <li>
          <badge type="info">booking site</badge>
          Ability to process $0 totals on the booking site.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Gave the manager role access to the bookings feature.
        </li>
        <li>
          Validating preset value amounts for gift card purchases on the booking site.
        </li>
        <li>
          Added the ability to delete preset gift card value on gift card settings.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(55)">November 8, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[55] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">payments</badge>
          Gift card configuration under Payment Settings. Note: The gift card feature is incomplete!
        </li>
        <li>
          <badge type="danger">payments</badge>
          Ability to purchase gift cards on booking site. Note: The gift card feature is incomplete!
        </li>
        <li>
          <badge type="success">hints</badge>
          Ability to configure hints to not decrement hint count on player's hint display.
        </li>
        <li>
          <badge type="success">hints</badge>
          Improvements to the UI of the hint configuration page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the hint timer such that the final time goes to 00:00:00 rather than 00:00:01.
        </li>
        <li>
          Updated the CORS policy on the S3 bucket which stores hint images to allow for uploads from authorized sources.
        </li>
        <li>
          Fixed the issue where taxes and fees wheren't calculated correcly across all items in cart (internal cart view).
        </li>
        <li>
          Fixed the issue where promo codes were compounding in cart (internal cart view).
        </li>
        <li>
          Fixed the issue where default promo codes did not account for all applicable games in basket (only one at a time).
        </li>
        <li>
          Implemented archival of taxes (instead of tax deletion) to allow for record retention.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(54)">November 1, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[54] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">bookings</badge>
          Added support for pricing categories and ranges across the booking site.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Implemented the notion of tickets to track which ticket types were purchased for a given booking.
        </li>
        <li>
          <badge type="success">games</badge>
          Added the ability to set the minimum required number of participants for each pricing category.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Validation for number of participants against the defined minimum and maximum values for a given game.
        </li>
        <li>
          <badge type="primary">security</badge>
          Server side validation on pricing fields to prevent parameter tampering on the booking site.
        </li>
        <li>
          <badge type="info">checklist</badge>
          Added checklist start time field as well as the computed total time on checklist history page.
        </li>
        <li>
          <badge type="warning">analytics</badge>
          Added matching charts to data tables on game dashboard page.
        </li>
        <li>
          <badge type="success">games</badge>
          Added the ability to configure game pricing according to a new structure. Included the ability to define pricing with categories and player ranges, as well as the option to charge per person or flat.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the issue where cancelling a transaction with an already cancelled booking opened up an extra booking slot.
        </li>
        <li>
          Changed the customer list page to also show customers acquired from transactions (not just waivers).
        </li>
        <li>
          Updated the color for the "paid" label on booking calendar view from red to green.
        </li>
        <li>
          Updated the Date object constructor to avoid date errors when formatting day of the week.
        </li>
        <li>
          Fixed the issue where default date picker formatting generated an error on promo code creation.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(53)">October 25, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[53] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">transactions</badge>
          Added the ability to add custom items to an existing transaction.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Implemented transaction activity records for custom items, promos, taxes, and fees.
        </li>
        <li>
          <badge type="warning">analytics</badge>
          Updated the game dashboard with accurate and more useful data.
        </li>
        <li>
          <badge type="success">games</badge>
          Added the ability to configure game pricing according to a new structure. Included the ability to define pricing with categories and player ranges, as well as the option to charge per person or flat.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Removed the static "paid" label on player accounts.
        </li>
      </ul>
    </div>


    <h4 v-on:click="toggle(52)">October 18, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[52] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">booking site</badge>
          Added the embedding code snippet to booking site settings.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Linked taxes and fees to transactions whenever a new tax or fee is created.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Created a new tab for listing taxes and fees associated to a transaction.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Added the ability to add and delete taxes and fees for a transaction.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Created a tab for promo codes associated with a transaction, and the ability to add new promo codes.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Implemented unique waiver link associated with bookings for a given transaction.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Added the option to include the unique waiver link in the booking checkout process.
        </li>
        <li>
          <badge type="info">waivers</badge>
          Added the option to include the unique waiver link in the booking confirmation email.
        </li>
        <li>
          <badge type="success">hint system</badge>
          Converted autosync to optional and off by default.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the CORS policy on S3 buckets preventing image upload for the hint system and game images (broke when setting up CDN).
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(51)">October 11, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[51] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">booking site</badge>
          Added rate (per game or per person) to game details page on booking site.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added notes count bubble on the bookings calendar view.
        </li>
        <li>
          <badge type="danger">booking site</badge>
          Made the calendar view on the booking site optional and configurable.
        </li>
        <li>
          <badge type="danger">booking site</badge>
          Made the order of games shown on the booking site customizeable.
        </li>
        <li>
          <badge type="danger">booking site</badge>
          Added the feature to customize the appearance of booked or blocked slots on the booking site.
        </li>
        <li>
          <badge type="danger">booking site</badge>
          Added fields to configure custom text for booked and blocked slots on booking site.
        </li>
        <li>
          <badge type="danger">booking site</badge>
          Improve the layout of the booking site settings page.
        </li>
        <li>
          <badge type="danger">booking site</badge>
          Added promo code input field on the customer facing booking site.
        </li>
        <li>
          <badge type="primary">localization</badge>
          Added a localization setting to configure whether day of the week will be shown across the application.
        </li>
        <li>
          <badge type="danger">payments</badge>
          Added validation to promo code dates to prevent invalid date ranges.
        </li>
        <li>
          <badge type="danger">payments</badge>
          Show promo codes and total discount value on transaction details page.
        </li>
        <li>
          <badge type="success">hint system</badge>
          Added heartbeat messages on hint control panel to sync timer and hints to connected screens (and removed the sync button).
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Relaxed the overly restrictive zip and cvv code check on booking site.
        </li>
        <li>
          Removed the redirect to hint history page when saving the hint log.
        </li>
        <li>
          Adjusted fullscreen dimensions for videos and images on hint display.
        </li>
        <li>
          Fixed the roundup issue during amount formatting for Square payments.
        </li>
        <li>
          Fixed the due amount value when cancelling a transaction to reflect the amount owed to player.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(50)">October 4, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[50] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">payments</badge>
          Ability to create, edit, and delete promo codes.
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Ability to apply promo codes on internal transactions when creating a booking (list view, calendar view, cart).
        </li>
        <li>
          <badge type="danger">transactions</badge>
          Added more fields to csv download for transactions.
        </li>
        <li>
          <badge type="success">hint system</badge>
          Ability to customize hint icons.
        </li>
        <li>
          <badge type="success">hint system</badge>
          Improved hint system logging.
        </li>
        <li>
          <badge type="success">hint system</badge>
          Button to sync hint screens to the game master control panel.
        </li>
        <li>
          <badge type="success">hint system</badge>
          Showing the number of connected screens on the game master control panel.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the issue where it was possible to make a purchase without anything in cart for $0 on the booking site.
        </li>
        <li>
          Fixed the caching issue leading to websocket connection being made to the wrong game if it was previously visited in the browser.
        </li>
        <li>
          Addressed the double submit issue specific to Stripe payments leading to accidental duplicate payments.
        </li>
        <li>
          Implemented live vs sandbox check on processing refund for Authorize.net integration.
        </li>
        <li>
          Addressed the reemerged Stripe refund issue on internal transactions.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(49)">September 27, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[49] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="danger">schedules</badge>
          Capped the date range for finite schedules and closed period to 12 months.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Implemented the ability to charge a partial amount when creating a booking on the admin site.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added the ability to waive taxes and fees on internal transactions.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Revamped the booking notes feature, adding headline note section on list and calendar view, as well as the ability to mark a note as important.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Improved the layout of the even slot content on calendar view.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added failed transaction alert on request payment page.
        </li>
        <li>
          <badge type="success">automated clues</badge>
          Added the ability to save the hint log and associate it to a game instance.
        </li>
        <li>
          <badge type="info">customer profile</badge>
          Added group photos to customer profile (in addition to player photos).
        </li>
        <li>
          <badge type="info">customer profile</badge>
          When completing an internal transaction, the provided customer data is saved to the company customer profile.
        </li>
        <li>
          <badge type="success">photos</badge>
          Revamped the feature to assign photos to players and game instance.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Altered the booking site settings page to display by group rather than by company.
        </li>
        <li>
          Excluded archived games from being listed on game schedules.
        </li>
        <li>
          Corrected the transaction object values when a booking or transaction is cancelled.
        </li>
        <li>
          Preventing checklists from disappearing whenever there are no associated game instances.
        </li>
        <li>
          Added the "in cart" icon for "Call to book" slots that are in cart.
        </li>
        <li>
          Defaulting a new booking slot on calendar view to 1 hr.
        </li>
        <li>
          Fixed the feature to edit of puzzles on game history page.
        </li>
        <li>
          Changed the button text on checklist submit to "Complete checklist".
        </li>
        <li>
          Fixed permissions on all settings pages such that a user can only view setting for groups they are a part of.
        </li>
        <li>
          Restricted the list of available bookings shown on photos to the selected group.
        </li>
        <li>
          Fixed the bug where starting timer didn't work after overriding the time.
        </li>
        <li>
          Fixed the last name dynamic variable on photo emails to prevent null values.
        </li>
        <li>
          Fixed the issue where you could check in to multiple games on waiver even when the custom setting doesn't allow it.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(48)">September 15, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[48] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">general</badge>
          Breadcrumbs where applicable across the site.
        </li>
        <li>
          <badge type="success">games</badge>
          Exposed and make editable start and end dates on game history details page.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Icon to add new booking per row on the bookings list view.
        </li>
        <li>
          <badge type="success">automated clues</badge>
          Improved hint control panel layout.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added tax and fee information to transaction emails.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Added support for minimum and maximum booking time on a booking slot basis in addition to the schedule setting.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the formatting of the customer birthday field on the customer details page.
        </li>
        <li>
          Added client-side validation on the group code field.
        </li>
        <li>
          Fixed the issue with stripe refunds for booking made over bookings site.
        </li>
        <li>
          Fixed the time calculation on the game tracker form to factor in days and not only times.
        </li>
        <li>
          Fixed the issue where interacting with hint timer interrupted hints on screen.
        </li>
        <li>
          Fixed the issue where creation of finite schedule with an existing recurring schedule didn't populate booking slots correctly.
        </li>
        <li>
          Addressed the issue where the cron job to populate booking slots was not respecting the end date range for finite schedules.
        </li>
        <li>
          Fixed the issue where the minimum and maximum booking rule didn't apply for booking slots without an attached schedule.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(47)">September 8, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[47] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">checklists</badge>
          Overhaul of the checklist feature. Added support for unlimited checklists that can be optionally tied to games.
        </li>
        <li>
          <badge type="warning">checklists</badge>
          Ability to add images to checklist steps.
        </li>
        <li>
          <badge type="warning">checklists</badge>
          Ability to mark checklist steps as optional.
        </li>
        <li>
          <badge type="danger">bookings</badge>
          Ability to define fees for bookings.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the issue where the "removed"  booking slot status was preventing the creation of new booking slots.
        </li>
        <li>
          Fixed the issue of insufficient character limit on retrieving the game pricing object, which was causing issue on booking slot edit.
        </li>
        <li>
          Fixed the automated hints timer to allow timer start after timer reset.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(46)">August 31, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[46] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Transactions dashboard.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to edit end date on game history.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Labeling booking slots that are in cart on the calendar and booking list view.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Revamped email options on transaction details page and included informational text on why an email option might not be available for a given transaction.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Replaced the OTC logo on the login page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added the checkbox to send payment request when creating a new booking (list, calendar, and cart mode).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Showing and computing taxes on internally made bookings and on transaction details page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added a button to bulk delete manually created available slots on schedules page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Removed empty calendar space on calendar view (wherever slots don't exist).
        </li>
        <li>
          When editing an exist booking slot, ensure that it lands on the correct day.
        </li>
        <li>
          Fixed user role permissions validation on the global group dropdown.
        </li>
        <li>
          Included blocked slots on the booking site and marking them as "Sold out".
        </li>
        <li>
          Show the cart button on booking slots that are marked as "check in but no booking".
        </li>
        <li>
          URL encoded parameters in query strings handling filters.
        </li>
        <li>
          Fixed the issue where booking slots for September didn't appear on the booking site calendar due to improper initiation of the date object.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(45)">August 22, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[45] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Added a button to mark a game reset as "unreset".
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added a customizeable call to book text and link for call to book slots on schedule settings.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Removed the feature to add and delete a booking site setting and instead converted it to exist for all company groups.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Created validation on booking site settings preventing a booking site from being activated if no games and no payment gateway are configured for the group.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Applied the order of puzzles defined under game settings to the clue display page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Replaced a buggy library used for the hint system timer to fix timer desyncs and inconsistencies when tab is inactive.
        </li>
        <li>
          Fixed the issue on calendar booking view where creating a booking set the wrong date for the displayed landing date.
        </li>
        <li>
          Added a horizontal margin to text clues on the hint display.
        </li>
        <li>
          Made it so the "Override time" button is visible even when the timer is set to hidden.
        </li>
        <li>
          Added a booking slot lock to the beginning of the function handling customer bookings to prevent race conditions on booking a game.
        </li>
        <li>
          Fixed the issue where signing a waiver for a game removed the slot from the booking site.
        </li>
        <li>
          Improved the layout and size of time slots on the booking site with custom call to book text.
        </li>
        <li>
          Fixed the issue where you couldn't delete "call to book" slots.
        </li>
        <li>
          Added dynamic screen resolution check to hint display so that the background setting can be applied as fullscreen even as screen size changes.
        </li>
        <li>
          Fixed the issue where a missing the call_to_book field prevented the creation of individual time slots.
        </li>
        <li>
          Fixed the issue preventing a five stars difficulty rating from being shown on the booking site.
        </li>
        <li>
          Added the missing statement to create a payment request email type when creating new company groups.
        </li>
        <li>
          Added validation to customer credit payments on transaction details page.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(44)">August 14, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[44] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to customize steps on the advanced game tracker (photo and puzzles steps are now optional).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Game tracker settings are now auto-populated for all existing groups with simple tracker as the default setting.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability for manager and admin role to view, delete, and reassign all in-progress game tracker drafts (advanced mode).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added "call to book" setting on schedules. It is possible to mark a slot as "call to book" on a slot-by-slot basis or in bulk.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success ml-2">customer portal</badge>
          Added a "pay on arrival" option to game pricing settings. A game with "pay on arrival" set will not require payment to book on the booking portal.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added support for Square for payment refunds.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Broke down the "Edit schedule" feature into two tabs (general settings and schedule). Editing the general settings will not regenerate booking slots.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Updated the custom hints controls page and moved the custom hints feature to the top of the page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added the feature to archive a tax object.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Selecting a different game from dropdown now correctly updates pricing and subtotal when editing or creating a booking (calendar and list mode).
        </li>
        <li>
          Fixed the logout button placement on mobile view (admin and customer portal).
        </li>
        <li>
          Added the activity record for cash/POS payment event.
        </li>
        <li>
          Fixed the issue where a Stripe payment intent function didn't add up percentage-based taxes correctly.
        </li>
        <li>
          Fixed the round-up issue on the booking site to ensure that pricing is accurate to the nearest cent.
        </li>
        <li>
          Update the timezone file reference on the feature to create a new group.
        </li>
        <li>
          Replaced the default waiver text on waiver settings.
        </li>
        <li>
          Fixed the issue on automated hints where interfacing with any of the timer buttons cleared existing hints on customer-facing display.
        </li>
        <li>
          Applied localization function to pricing displaced on calendar event (calendar mode)
        </li>
        <li>
          Updating booking slot status to 'available' when deleting or moving the last remaining waiver associated with that booking slot.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(43)">August 7, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[43] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">customer portal</badge>
          Back buttons on waiver.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Mobile-friendly view for the bookings page (calendar view, list view, and basket).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Mobile-friendly view for the waiver history page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Button to navigate to cart from booking list and calendar view.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Handling cases where schedule_id field is null for booking slots (e.g. when a manual booking is created).
        </li>
        <li>
          Normalizing card expiry format across supported payment gateway.
        </li>
        <li>
          Removed the audio html tag from clue display page, so that no widget appears for audio clues.
        </li>
        <li>
          Calendar view on the booking site should increment by week rather than by day in desktop mode.
        </li>
        <li>
          Applied localization settings the calendar page and basket.
        </li>
        <li>
          Validation on end time and start time on the calendar page.
        </li>
        <li>
          Fixed the issue where start and end time wasn't updating correctly due to localization implementation.
        </li>
        <li>
          Better error alerting on the booking site settings.
        </li>
        <li>
          Fixed the issue where a trailing space in group name prevented the updating of users under user management.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(42)">July 31, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[42] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Improved the feature to edit booking on list and calendar view, consolidating edit booking slot, edit customer, add payment, and add players on the same view.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added the feature to edit customer on the transaction details page
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added activity record when a booking or a transaction is updated.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to dynamically set the timer on the hint control page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Implemented a setting to add a custom sound file and configure it to play before certain hint types on the hint system.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Improved CloudWatch logging.
        </li>
        <li>
          Improved the mobile view on the simple game tracker page.
        </li>
        <li>
          Fixed the bug where a simple game tracker form couldn't be submitted when a draft existed for a given game.
        </li>
        <li>
          Fixed text alignment on the cart section of the booking site, preventing text wrapping on new line.
        </li>
        <li>
          Added redirect to login when the user navigates to an unauthorized section of the site.
        </li>
        <li>
          Fixed the issue where duplicate slots were created on schedule update whenever future booked or completed slots exist for a given game.
        </li>
        <li>
          Fixed the VPC misconfiguration on all backend functions.
        </li>
        <li>
          Changed the color mismatch on the alert box for error and success messages on the login page.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(41)">July 24, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[41] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Feature to add arbitrary payment to a transaction (below or at the due amount).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Support for Stripe on the add payment feature.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: button to hide the timer button dynamically.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Marking booking slots that are within the defined minimum period as "Call to book".
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Function to create an activity record when a transaction or booking is cancelled.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Added customizable visibility option to game info on booking site cards (game title, number of players, diffulty, duration).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to modify customer information scoped to company.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Improved booking and transaction notes sections and added tags to distinguish between the two.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability change a booking slot status to "Call to book".
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added a link to customer transactions on the Customer Details page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Removed problematic fonts from the font options list.
        </li>
        <li>
          Fixed the issue causing the start timer button to break after pressing the reset timer button on the hint control page.
        </li>
        <li>
          On automated hints, prevented the feature to clear hints from counting as a used hint.
        </li>
        <li>
          Added localization options to calendar on the booking site.
        </li>
        <li>
          Fixed the redirect issue on the sidebar image link to take into account user-defined settings.
        </li>
        <li>
          Fixed the issue preventing the time field from factoring in the time slot of the current booking on the transaction details page.
        </li>
        <li>
          On transaction details page, modified the confirmation popup content on edit booking depending on whether the automated email setting is configured as active.
        </li>
        <li>
          Preventing the duplication of booking slots when reschduling a booking to a new time slot.
        </li>
        <li>
          Fixed duplicate entries on the list of incomplete bookings on the game tracker.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(40)">July 17, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[40] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to edit individual bookings on Transaction Details page, including increasing group size.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated emails to company users (admins and managers) upon transactions events (new transaction, updated booking, added payment, cancelled booking, cancelled transaction).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Button to resend a confirmation email on Transaction Details page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Consolidated booking details and transaction details page and updated the link from booking list and calendar view.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Changed the button to add minor from icon to text on the waiver form.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Exposed customer phone and address on customer details page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Applied localization on customer phone number on the internal site.
        </li>
        <li>
          Resolved bug preventing access to the bookings page when no payment gateway is set up.
        </li>
        <li>
          Fixed the truncation of the pricing object leading to groups not populating on the dropdown on Edit Game page on some instances.
        </li>
        <li>
          Validation and error handling of fields on the payment gateway page.
        </li>
        <li>
          Fixed the invalid amount populated in the activity log upon creating a "pay on arrival" booking.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(39)">July 10, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[39] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Send payment request feature.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: Tooltip instructions on how to whitelist domain for autoplay
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Automated hints: Fixed resolution and sizing on images and videos.
        </li>
        <li>
          Fixed scroll issues (not scrolling to top when loading components and infinite scroll down).
        </li>
        <li>
          Fixed container height on hint display page in fullscreen (background didn't cover the entire screen).
        </li>
        <li>
          Fixed insufficient authorization on hint display.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(38)">July 3, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[38] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: drag and drop layout editor.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Square payment gateway integration.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Strong customer authentication on Square payments.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Booking site settings: added customizable terms of service link.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Booking site settings: validate http protocol on custom redirect and TOS URL value.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Automated hints: properly terminate stale websocket connections.
        </li>
        <li>
          Automated hints: fixed timer desynchronization.
        </li>
        <li>
          Automated hints: fixed reset timer inconsistency.
        </li>
        <li>
          Booking site: preventing double submit on request to complete booking.
        </li>
        <li>
          Automated hints: fixed the issue preventing video and audio hints to play consecutively.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(37)">June 26, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[37] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Added line item price and payment status to booking confirmation email template.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Reimplemented the payment form for Stripe integration on booking site to improve the mobile experience.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          <badge type="info" class="ml-2">security</badge>
          Added function to validate payment amount against set price on the server side for Stripe payments.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Added UK-friendly location field to waivers.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Added UK-friendly phone field to waivers and booking site.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Displaying all available booking slots for a given day on step 1 of the booking site.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Support for payments on arrival.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Applying group format and localization settings on updated booking email template.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Applying group format and localization settings on cancelled booking email template.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Applying group format and localization settings on cancelled transaction email template.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added ability to cancel a transaction.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added support for cash payments.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Added a date picker to the calendar view on booking site.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Added the feature to add a custom redirect link to redirect user to any URL after making a booking.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Preventing booking slots from appearing on the first page of the booking site when they are already booked.
        </li>
        <li>
          Added timezone codes to the timezone dropdown on group settings page and updated timezone list.
        </li>
        <li>
          Removed legacy payment_type and payment_timestamp fields on transaction object.
        </li>
        <li>
          Removed clues received from game history on customer profile.
        </li>
        <li>
          Added custom date format to date picker on the booking site.
        </li>
        <li>
          Ensured that date remains the same when navigating between calendar view and game view on the booking site.
        </li>
        <li>
          Removed clues received from game history on customer profile.
        </li>
        <li>
          Cleaned up the review step on the booking site for better mobile experience.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(36)">June 20, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[36] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Converted automated email settings to per-group rather than a single setting for company.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Updated booking site to support flat price for a game.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Applied localization settings to customer facing booking site.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Applied localization settings to customer facing waivers.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Updated booking confirmation email template to support localization settings per company group.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed the issue on company group update where the specified country code was overriding group code.
        </li>
        <li>
          Fixed the time formatting on waiver (overlooked after deploying localization)
        </li>
        <li>
          Applied quick fix to the photo features which were affected by changes to automated email settings restructure.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(35)">June 12, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[35] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Added address fields on company groups.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added localization and formatting settings to groups.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Improved the flow to create and edit a company group.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Adjusted schedule priority to allow closed periods overrides other types of schedules.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Added available booking slots to the first step of the customer facing booking site.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Added a more robust calendar module to the customer facing booking site.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed mobile view on customer facing booking site.
        </li>
        <li>
          Added the function to set up payment settings when creating a new company.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(34)">June 05, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[34] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Customer facing booking site to serve supported payment gateways.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Replaced the rich editor library used for waiver text and email templates.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Unwanted double spacing on automated and mass emails.
        </li>
        <li>
          Inconsistent link color on automated and mass emails.
        </li>
        <li>
          The color black wasn't correctly applied to text generated by rich editor.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(33)">May 29, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[33] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Stripe payment gateway integration.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Serving the payment form based on enabled payment gateway on internal payment features.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(32)">May 23, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[32] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Minimum booking notice on game schedules.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Maximum booking in advance on game schedule.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Maximum booking in advance on game schedule.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to process payments with Authorize.net integration (sandbox and live mode).
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(31)">May 15, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[31] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to take photos to on game form history page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Supporting base pricing by game.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to add booking to cart and create a transaction with multiple bookings at once.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added customer phone number to bookings page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to override price on a booking.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Column to show the number of people in a group and their names on the game history page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Supporting customer credit on the feature to add payment to booking and on the basket page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Removed login/register links on the waiver page.
        </li>
        <li>
          Fixed the double-submit issue on waivers.
        </li>
        <li>
          Preventing photos from being assigned to incomplete games.
        </li>
        <li>
          Added success message on saving game settings.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(30)">May 8, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[30] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Simple Game Tracker: ability to select forms by date.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to add, edit, and delete customer credit on the customer info page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to apply customer credit when creating a booking.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Tab to see the list of all games that had a waiver signed but where the corresponding game tracker form was never submitted.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Waiver templates display by global group setting. (When group changes, so will the waiver template).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to look up an existing customer and pre-populate customer info when creating a new booking.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Booking view defaults to the most recent bookings view used (calendar or list).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          The calendar time bar defaults to 10am or to the first booking time.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Overflow hidden on resource title bar on calendar view.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Added success prompt on Authorize.net credential activation.
        </li>
        <li>
          Fixed the date range filter on waiver history page.
        </li>
        <li>
          Fixed the start time on simple game tracker from being overridden by subsequent waivers.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(29)">May 2, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[29] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Calendar view for bookings.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Option to upload photos from photo gallery on mobile devices.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Label on photos to show whether or not they have been emailed to group.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(28)">April 23, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[28] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Bookings and transactions are now grouped by company groups rather than companies.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Photo settings are created and populated for all groups. Displaying "not configured" label on photo settings that have not been set up.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to copy photo setting to a different group.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Sort photos by recent first on Photos page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Resend account activation link on User management page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed sidebar scroll issue on Windows.
        </li>
        <li>
          Fixed the duplication of reschedule policy field on automated emails page.
        </li>
        <li>
          Fixed take photos feature on advanced game tracker.
        </li>
        <li>
          Remove horizontal scroll bar on hints display page.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(27)">April 17, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[27] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Closed periods on schedules.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to edit individual time slots on schedules.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Support for multiple schedules per game.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Display schedules by company group.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Timeslots defaulting to PM.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Filter by 'Blocked' status on Bookings page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed table scaling issue on simple game tracker.
        </li>
        <li>
          Fixed the waiver editor issue preventing black text color from being applied to waiver text.
        </li>
      </ul>
    </div>


    <h4 v-on:click="toggle(26)">April 9, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[26] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to add tags to customers.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Rich text editor on the waiver text field.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Auto-populating waiver settings for all groups (on group creation).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Global group filter.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Displaying waiver history, games, booking slots on game tracker, game history, game reset history, hints, hint settings, and customers based on group.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Popup notifications for updating and creating email templates.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Name of the person who made the booking displayed on advanced tracker.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Puzzle field validation improvement on advanced tracker.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Redirect to game history page after submitting game tracker form.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Button to send photo to everyone on game history page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Game difficulty now optional on game setup.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added game booking time on reset history page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Validation on empty group when creating a game.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Updated element-ui library to the latest version.
        </li>
        <li>
          Set booking_site_settings link to update when creating a game.
        </li>
        <li>
          Fixed data type which prevented the display logo from updating correctly on hint configurations.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(25)">April 2, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[25] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Image overlays for customer photos.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Changed the data type of the photo timestamp to record time in addition to date.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to toggle groups on the portal navbar.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Add the user's name to the top right corner dropdown.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Incorrect number of hints when submitting the advanced tracker.
        </li>
        <li>
          Photos were linked to companies rather than company groups.
        </li>
        <li>
          Mobile view for photos broke when introducing overlays.
        </li>
        <li>
          Photos on player side broke as a result of restructuring the photos object.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(24)">March 19, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[24] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to change game master for a completed game form (admin-level feature)
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Simple tracker: Removed the notes field and added the team name field.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Simple tracker: Field validation and default values.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Simple tracker: Auto-populating start and end-times based on booking.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Bug preventing you from deleting a game tracker settings template if it's the only one in the list.
        </li>
        <li>
          Users without proper permissions could see the game tracker settings button.
        </li>
        <li>
          Bug on edit game, causing photo upload to not complete.
        </li>
        <li>
          Bug on simple game tracker form, making on one record visible on the app.
        </li>
        <li>
          Waiver template: Embedding iframe code snipped had an incomplete source URL.
        </li>
        <li>
          Bug on deleting a company group (trying to write to a legacy table caused the request to fail)
        </li>
        <li>
          Better handling on deleting waivers that already have completed bookings associated to them.
        </li>
        <li>
          Creating a schedule didn't create slots on the current day.
        </li>
        <li>
          The date/time fields on the Reset list pulled data from legacy fields.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(23)">March 12, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[23] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Simplified game tracker form.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Game tracker settings.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(22)">March 5, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[22] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Configurable taxes on bookings site.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to activate and deactivate tax.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Filters on the bookings page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Additional columns on booking list (name of person who booked and group size)
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Better styling the calendar view on the customer facing booking page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Additional customizable fields on the booking site.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success" class="ml-2">customer portal</badge>
          Ability to select which games appear on customer facing booking page.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          "Name on card" field on billing page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Booking amount displays the wrong value on the transactions history page.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(21)">February 26, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[21] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to refund payments.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Removed past bookings slots from the customer facing bookings page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          CSV download on transactions.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Filters on transactions.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Made columns on the transactions table more granular.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          No data handling on transactions.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to refund as customer credit.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Previous dates were showing as available on booking calendar (customer view).
        </li>
        <li>
          Total and subtotal values were wrong when submitting a payment via bookings page.
        </li>
        <li>
          Incorrect number of mailing contacts.
        </li>
        <li>
          Not checking if a game instance is a draft before creating a reset instance.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(20)">February 18, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[20] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Mass email: set email recipients to BCC
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Mass email: display which group a contact belongs to on Contacts page
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Mass email: add contacts to an existing group on the Contacts page
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Waivers: add the ability to set marketing fields as active and/or required
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Mass email: store email content as objects in S3
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Mass email: when deleting an email template, it should also delete the S3 object storing email content
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Mass email: increased the number of contacts you can view per page to 250
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Mass email: validation on email field
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          State variables should clear on email template edit and create
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(19)">February 6, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[19] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Pagination of contacts on email group page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Configurable colors of hint icons on the in-game hint screen.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge class="ml-2" type="success">customer portal</badge>
          Configurable waiver sections (ability to remove them or change section names).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added customizable reply-to and name fields on automated emails and mass emails.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Added font select module to email content component on automated and mass emails.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Made the lambda function to add contacts to email group asynchronous in order to be able to handle large number of contacts without timing out.
        </li>
        <li>
          Fixed bug on contacts which returned incorrect results.
        </li>
        <li>
          Fixed the order of puzzles for a completed game form (it was intermingling completed and incompleted puzzles).
        </li>
        <li>
          Added nodemailer to the function to send mass emails.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(18)">January 30, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[18] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Filters on email group contacts.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to select all contacts on email groups.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Button to copy a waiver template to a new company group.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Editing group name now updates waiver URL.
        </li>
        <li>
          Changed console thumbnails to fit vs cutting image size.
        </li>
        <li>
          Handling blank birthdays throughout the app.
        </li>
        <li>
          Fixed email groups not populating on mass email templates.
        </li>
        <li>
          Game tracker form step one was showing incorrect text and icon.
        </li>
        <li>
          Handling the case where players enter a blank line when signing a waiver for a minor.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(17)">January 23, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[17] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          <badge class="ml-2" type="success">customer portal</badge>
          Configurable waiver logo size and fit.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Reset all filters button on game history, waiver history, reset history, and customers pages.
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Signing a waiver for a game will make it appear in the upcoming games section.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to edit waiver on custome info page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to add a player to game instance.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Link to customer info page from game history page.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Data handling and validation issues introduced in the previous sprint to the game tracker form.
        </li>
        <li>
          Authorization bug on reset history filters.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(16)">January 16, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[16] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Using game tracker without needing a signed customer waiver.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Game tracker maintains state (data is saved upon page refresh).
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Analytics and game histories exclude game tracker drafts.
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Removed unnecessary horizontal scroll bars on waiver table.
        </li>
        <li>
          Fixed pagination issue when using "Today's bookings" filter.
        </li>
        <li>
          Edit waiver (reassigning waiver to another booking) didn't change booking status correctly.
        </li>
        <li>
          Reset history log didn't display correct timestamps (didn't convert to local TZ).
        </li>
        <li>
          Reset checklist used the wrong id when recording which user reset a game (the id of the game master who ran the game was used instead of the user who submitted the reset form).
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(15)">January 8, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[15] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Additional customizable fields on Waiver configuration: card text color and font, background text color and font
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          <badge class="ml-2" type="success">customer portal</badge>
          "Tell us more about yourself" section on Waivers which includes the following form fields: level of experience, where they heard about the company, and location. These fields are configurable.
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Button to delete a game instance
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Button to edit the team name on game history page
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Game filters didn't return correct data for certain users
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(14)">January 1, 2023
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[14] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Arranged leaderboards by teams rather than by individual players
        </li>
        <li>
          <badge type="success">customer portal</badge>
          Made leaderboards available to players
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp; <badge type="success">customer portal</badge>
          Implemented additional fields on leaderboards: completion time, number of players, number of clues
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Leaderboard settings page to allow leaderboard customization for each game
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to display leaderboards in full screen mode
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(13)">December 25, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[13] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to group players into teams
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: ability to take back a hint
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: ability to reset timer
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: timer and hints used appears on game master dashboard
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: download hint log as csv
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(12)">December 5, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[12] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: configuration
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: player portal configuration
        </li>
        <li>
          <badge type="warning">admin portal</badge>
          Automated hints: game master portal
        </li>
        <li>
          Player-facing hint display
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(11)">November 7, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[11] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          List of transactions.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Transaction details.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to send PDF attachments in booking confirmation emails as an optional setting.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to set the time at which reminder and follow-up email will be sent to customers.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to add customer to an available booking.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Send automated email when a booking slot has been cancelled.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Transaction activity.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Transaction and booking notes.
        </li>
      </ul>

      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Rearchitected the relationship between transactions, payments, and bookings. Added more fields to transactions and bookings object.
        </li>
        <li>
          Disabled past booking slots on the customer-facing booking site
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(10)">October 2, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[10] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Ability to cancel a transaction, and optionally send an email to customers.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to cancel a booking, and optionally send an email to customers.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to select multiple games per customer checkin is optional and can be configured in admin portal.
        </li>
      </ul>

      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Date/time format on booking confirmation emails
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(9)">September 25, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[9] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Default values (email content, subject) for automatic email configurations.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Applied custom email settings to photos email.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Applied custom email settings to updated booking email (when payment is added or when a booking is edited).
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Edit a booking slot
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Dynamic variables in custom automated emails.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to activate and deactivate automated emails. Showing statuses on the UI.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to block off a booking slot. It will show as sold out on customer booking site.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to add notes to a booking slot.
        </li>

        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          <badge type="success">customer portal</badge>&nbsp;
          Custom text color on waivers.
        </li>
      </ul>

      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Field validation on "Add new payment" form.
        </li>
        <li>
          Removed infinite loader on waiver 404 page.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(8)">September 18, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[8] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Booking confirmation email customization page. (Only booking confirmation email template currently being applied to customer emails).
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Redesign of the bookings page (list view). Added options to add a custom booking slot and a private booking with or without payment.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Creating a booking (whether by admin or by customer) triggers a confirmation email.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          <badge type="success">customer portal</badge>&nbsp;
          Renamed "Minors" to "Children" on waivers.
        </li>
      </ul>

      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          It was possible to create duplicate waivers (i.e. for a customer to check in multiple times to the same booking slot)
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(7)">September 11, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[7] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          <badge type="success">customer portal</badge>
          Booking confirmation email triggers when a booking is made.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Apply additional payments to an existing booking.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Support multiple transaction types for a booking.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Booking details page (includes transaction info, customer waivers, link to game history etc)
        </li>
      </ul>

      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Delete booking button only appears when a booking does not have a transaction associated with it, preventing users from deleting existing transactions.
        </li>
        <li>
          Preventing duplicate game form submissions (only one game tracker form per booking slot).
        </li>
        <li>
          Fixed duplicate validation on checkin (it broke after we enabled the ability to check in to multiple games at once).
        </li>
        <li>
          Removed unfinished puzzles from customer view.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(6)">September 4, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[6] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>
          Hyperlink to game history from photos page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Removed the maximum cap on players when manually creating a booking.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Phone and email field validation on bookings.
        </li>
        <li>
          <badge type="info">in QA</badge>&nbsp;
          Added waiver details and PDF download to the customer details page.
        </li>
        <li>
          <badge type="info">in QA</badge>&nbsp;
          Show purchases on the customer details page.
        </li>
        <li>
          <badge type="info">in QA</badge>&nbsp;
          Ability to filter customers by multiple games played.
        </li>
      </ul>

      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          The price indicator on the booking feature did not account for decimals.
        </li>
        <li>
          Game analytics page didn't display correct solve times.
        </li>
        <li>
          Removed hints information from end user account.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(5)">August 28, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[5] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;&nbsp;<badge type="success">customer portal</badge>&nbsp;
          Email opt out field on waivers.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Copy timeslots from a given day on schedules.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Validation and alert on schedule conflicts.
        </li>
        <li>
          <badge type="info">in QA</badge>&nbsp;
          Customer details page.
        </li>
        <li>
          <badge type="info">in QA</badge>&nbsp;
          Customer list page.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(4)">August 21, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[4] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Define slot and gap duration on schedules.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Automatically generate and populate schedule slots from user-provided time range.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Button to clear all schedule slots.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Button to delete schedule slots on a given day.
        </li>
        <li>
          <badge type="default">backend</badge>&nbsp;
          Upgraded backend runtime to Nodejs 16 as v12 is being deprecated.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Custom fonts on waiver templates.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Auto-populate sample waiver text on waiver templates.
        </li>
      </ul>

      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Improved efficiency of the function that generates booking slots from a schedule.
        </li>
        <li>
          When archiving a company group, delete and deactivate associated waiver and booking site.
        </li>
        <li>
          Removed legacy link table from DB.
        </li>
      </ul>
    </div>
    <h4  v-on:click="toggle(3)">August 14, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[3] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="info">In QA</badge>&nbsp;
          Booking site settings feature, allowing users to customize their customer-facing booking site.
        </li>
        <li>
          <badge type="info">In QA</badge>&nbsp;
          Ability to set the booking site as active or inactive.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Showing additional booking information on Upcoming Bookings page: how much is due/paid, number of players the booking is for, and how many people checked in.
        </li>
        <li>
          <badge type="default">backend</badge>&nbsp;
          Timestamps for booking and payment events.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Confirmation alert when deleting a waiver template.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Delete waiver on Waiver History page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Ability to reassign a waiver to another booking slot on Waiver History page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Moved the "Add Puzzle" button on Create Game feature to the bottom so it's easier to access.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Card color on customer-facing waivers is now customizeable.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          A form to report bugs and feedback.
        </li>
        <li>
          <badge type="default">backend</badge>&nbsp;
          Added constraint that a company user must belong to at least one group
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Groups were not assigned to users upon creation. Now they are automatically assigned to all admins for a given company.
        </li>
        <li>
          Added a constraint/validation that a company user must belong to at least one group to prevent dangling users.
        </li>
      </ul>
    </div>

    <h4 v-on:click="toggle(2)">August 7, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[2] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">customer portal</badge>&nbsp;
          Ability to create an account for a minor from the account of a person who signed the minor's waiver. Past game data would be retained on the new account.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Including photo attachments in customer emails.
        </li>
        <li>
          <badge type="success">customer portal</badge>&nbsp;
          Updated password reset email.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Button to delete player photos on game history page.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Added a step to take photos on the game tracker form.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Track which user took a player photo.
        </li>
        <li>
          <badge type="success">customer portal</badge>&nbsp;
          Display photos that are associated to customer but not to games on player profile.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          This changelog.
        </li>
      </ul>
    </div>
    <h4 v-on:click="toggle(1)">July 31, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[1] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="success">customer portal</badge>&nbsp;
          Enable players to access their past games (photos and game stats) once their register an account on offthecouch.io
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Rearchitected the photos feature, enabling users to take multiple photos and then assign those photos to games or individual users
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Fixed dashboards (general and game-specific) which broke after we implemented the new booking architecture
        </li>
      </ul>
    </div>


    <h4 v-on:click="toggle(0)">July 24, 2022
      <i class="tim-icons icon-minimal-down"></i>
    </h4>
    <div v-if="collapse[0] == true">
      <p class="text-success text-uppercase">Improvements</p>
      <ul>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Added the option for the waiver text to be set to ‘None’, ‘External Link’, or ‘Text’ on the Waiver Setup page
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Removed legacy Waiver Template Preview code
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Incorporated waiver embedding HTML on the Waiver Setup page
        </li>
        <li>
          <badge type="info">other</badge>&nbsp;
          Set up a mailbox for offthecouch.io to be able to receive support emails
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Waiver setting to set custom background color of the Check-In form
        </li>
        <li>
          <badge type="success">customer portal</badge>&nbsp;
          Calendar widget on player checkin, allowing users to select any date rather than having to click on Next/Previous. Ensured that past dates are disabled on the calendar.
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Error handling on creating Company Groups
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Display teams on the Game History page and on Game Tracker form, as well as label which players are minors
        </li>
        <li>
          <badge type="success">customer portal</badge>&nbsp;
          Display a player’s team (including minor labels) on the end user account
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Display ‘minors’ label on the Waiver history page
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Removed the feature to delete game instances
        </li>
        <li>
          <badge type="default">backend</badge>&nbsp;
          Created a new status for a booking slot, allowing slots to show up on the game tracker form if some players checked in while no booking has been made
        </li>
        <li>
          <badge type="warning">admin portal</badge>&nbsp;
          Update the puzzle table on the Review step of the game tracker form to say yes/no instead of true/false
        </li>
      </ul>
      <p class="text-danger text-uppercase">Fixes</p>
      <ul>
        <li>
          Proper handling of an empty birthday value on My Profile
        </li>
        <li>
          Lambda trigger failure on password reset
        </li>
      </ul>
    </div>
  </card>
</div>
</template>

<script>
import {Badge} from "@/components";

export default {
  name: "ChangelogLegacy",
  components: {
    Badge,
  },
  data(){
    return {
      collapse: [],
    }
  },
  methods: {
    toggle(index){
      this.$set(this.collapse, index, !this.collapse[index])
    },
  }
}
</script>

<style scoped>

</style>
